@if (!viewDialogueBox) {
  <div class="addTask-button">
    <button class="btn btn-sm addbtndemo" (click)="openFPFormFeedback()" aria-label="AddTask">
      {{ "addTask" | translate }}
    </button>
  </div>
}
<p-dialog class="maxdialog" [(visible)]="displayDialogue" [style]="{ width: '70vw' }" [baseZIndex]="10000" position="left">
  <p-editor class="editor" [(ngModel)]="textDescription" [style]="{ height: '650px' }"></p-editor>
  <ng-template pTemplate="footer">
    <p-button label="Save" (onClick)="minimizeDialog()" [disabled]="!textDescription"></p-button>
    <p-button label="Cancel" (onClick)="cancelminimizeDialog()" severity="secondary"></p-button>
  </ng-template>
</p-dialog>

<p-dialog class="maxdialog" [(visible)]="displayDialogue1" [style]="{ width: '70vw' }" [baseZIndex]="10000" position="left">
  <p-editor class="editor" [(ngModel)]="textDescription1" [style]="{ height: '625px' }"></p-editor>
  <ng-template pTemplate="footer">
    <p-button label="Save" (onClick)="editminimizeDialog()" [disabled]="!textDescription1"></p-button>
    <p-button label="Cancel" (onClick)="canceleditminimizeDialog()" severity="secondary"></p-button>
  </ng-template>
</p-dialog>

<p-dialog class="maxdialog2" [(visible)]="displayDialogue2" [style]="{ width: '70vw' }" [baseZIndex]="10000" position="left">
  <p-editor class="editor" [(ngModel)]="textDescription2" [style]="{ height: '650px' }" [readonly]="true"></p-editor>
  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-end">
      <p-button label="Cancel" (onClick)="viewminimizeDialog()" [disabled]="!textDescription2"></p-button>
    </div>
  </ng-template>
</p-dialog>
<p-dialog
  [closable]="false"
  [(visible)]="displayFeedback"
  styleClass="overlayAddTask"
  [modal]="true"
  [baseZIndex]="10000"
  (onShow)="onShowAdd()"
  [style]="{ width: '698px', height: 'auto', 'max-height': '82vh' }"
  [draggable]="false">
  <ng-template #header>
    <div style="display: flex; align-items: center; justify-content: space-between; width: 100%; padding: 10px">
      <p style="display: inline-block; line-height: 0; font-size: 14px; margin: 0">
        {{ "createTask" | translate }}
      </p>
      <img (click)="CancelCreateForm()" src="../../../../assets/img/Group 8423.png" alt="cancel" style="width: 18px; cursor: pointer" />
    </div>
  </ng-template>
  <p-scrollpanel [style]="{ width: '100%', height: 'auto', overflow: 'visible' }" styleClass="createTaskDetails">
    <ng-template #content>
      <form [formGroup]="createForm" (ngSubmit)="CreateTask(createForm.value)">
        <div class="wrapper" style="margin-bottom: 2px">
          <div class="form-group form-inline taskName">
            <input
              type="text"
              pInputText
              class="form-control taskNameInput"
              id="taskNameAdd"
              maxlength="500"
              [class.invalid]="!createForm.valid"
              placeholder="{{ 'addTaskName' | translate }}*"
              formControlName="taskName"
              name="taskName"
              #testInput
              autocomplete="off" />
            <span class="privateSpan commonhead"></span>
            <div class="d-flex align-items-center w-fit">
              <p-checkbox name="privateTask" binary="true" inputId="privateTaskCreate" class="privateSpan" formControlName="privateTask"></p-checkbox>
              <label for="privateTaskCreate" class="ml-2">{{ "privateTask" | translate }}</label>
            </div>
            @if (createForm.controls["taskName"].errors) {
              <div>
                @if ((createForm.controls["taskName"].errors?.required && createForm.controls["taskName"].dirty) || !createForm.controls["taskName"].value) {
                  <div class="text-danger" style="font-size: 12px; margin-top: -14px !important">
                    <!-- {{'taskNameMandatory' | translate}} -->
                  </div>
                }
                @if (!createForm.controls["taskName"].valid && !createForm.controls["taskName"].errors?.required && createForm.controls["taskName"].dirty) {
                  <div class="text-danger" style="font-size: 12px; margin-top: -14px !important">
                    <!-- {{'validTaskNameMsg' | translate}} -->
                  </div>
                }
              </div>
            }
          </div>
          <div class="productSelection">
            <p class="commonhead commonBottom">
              {{ "selectProduct" | translate }}
              <span class="text-danger">*</span>
              @if (createForm.controls["selectedProduct"].errors || isValidProduct == true || isValidProduct1 == true) {
                <span>
                  @if (
                    (createForm.controls["selectedProduct"].errors?.required && createForm.controls["selectedProduct"].dirty) ||
                    !createForm.controls["selectedProduct"].value
                  ) {
                    <span class="text-danger" style="font-size: 12px; margin-top: -14px !important">
                      <!-- {{'mandatory' | translate}} -->
                    </span>
                  }
                </span>
              }
            </p>
            <p-select
              #dd
              [options]="product"
              filter="true"
              formControlName="selectedProduct"
              (onShow)="dd.resetFilter()"
              (onTextChange)="onChangeProduct($event)"
              placeholder="{{ 'selectProduct' | translate }}"
              optionLabel="name"
              styleClass="widthdropdownProjectCreate"
              appendTo="body"></p-select>
          </div>
          <div class="projectSelection">
            <p class="commonhead commonBottom">
              {{ "selectProject" | translate }}
              <span class="text-danger">*</span>
              @if (createForm.controls["selectedProject"].errors || isValidProject == true || isValidProject1 == true) {
                <span>
                  @if (
                    (createForm.controls["selectedProject"].errors?.required && createForm.controls["selectedProject"].dirty) ||
                    !createForm.controls["selectedProject"].value
                  ) {
                    <span class="text-danger" style="font-size: 12px; margin-top: -14px !important">
                      <!-- {{'mandatory' | translate}} -->
                    </span>
                  }
                </span>
              }
            </p>
            <p-select
              #projectdd
              [options]="projects"
              filter="true"
              (onShow)="projectdd.resetFilter()"
              formControlName="selectedProject"
              optionLabel="name"
              (onTextChange)="onChangeProject($event)"
              placeholder="{{ 'selectProject' | translate }}"
              styleClass="widthdropdown1Create"
              appendTo="body"></p-select>
          </div>
          <div class="projectSelection">
            <p class="commonhead commonBottom">
              {{ "selectPriority" | translate }}
              <span class="text-danger">*</span>
              @if (createForm.controls["selectedPriority"].errors) {
                <span>
                  @if (createForm.controls["selectedPriority"].errors || isValidPriority == true || isValidPriority1 == true) {
                    <span>
                      @if (
                        (createForm.controls["selectedPriority"].errors?.required && createForm.controls["selectedPriority"].dirty) ||
                        !createForm.controls["selectedPriority"].value
                      ) {
                        <span class="text-danger" style="font-size: 12px; margin-top: -14px !important">
                          <!-- {{'mandatory' | translate}} -->
                        </span>
                      }
                    </span>
                  }
                </span>
              }
            </p>
            <p-select
              [options]="priority"
              formControlName="selectedPriority"
              placeholder="{{ 'selectPriority' | translate }}"
              (onTextChange)="onChangePriority($event)"
              optionLabel="name"
              styleClass="widthdropdown2Create"
              appendTo="body"></p-select>
          </div>
        </div>
        <div class="editor" style="width: 100%">
          <p class="commonhead commonBottom widthTitle" style="width: 100%">
            {{ "desc" | translate }}
            <span class="text-danger">*</span>
            @if (createForm.controls["description"].errors || isValidDesc == true || isValidDesc1 == true) {
              <span>
                @if (
                  (createForm.controls["description"].errors?.required && createForm.controls["description"].dirty) || !createForm.controls["description"].value
                ) {
                  <span class="text-danger" style="font-size: 12px; margin-top: -14px !important">
                    <!-- {{'descriptionIsMandatory' | translate}} -->
                  </span>
                }
              </span>
            }
          </p>
          <p-editor
            formControlName="description"
            name="description"
            [style]="{ height: '220px','font-size': '18px' }"
            [required]="true"
            (onTextChange)="onChangeDescription($event)"
            styleClass="editorCreateTask"></p-editor>
          <span class="maximize" (click)="maximizeDescription()" style="cursor: pointer">
            <i class="pi pi-window-maximize"></i>
          </span>
          @if (isValidDesc == true || isValidDesc1 == true) {
            <span class="invalid-feedback" style="font-size: 12px !important">Please enter valid description.</span>
          }
        </div>

        @if (multipleTemplateList) {
          <div class="col-lg-12 col-md-12 col-sm-12 ticketType" style="padding-left: 0px; padding-right: 5px; margin-bottom: 4px">
            <p class="commonhead commonBottom" style="width: 130px; margin-right: 8px !important">
              {{ "templateType" | translate }}
              @if (createForm.controls["ticketType"].errors) {
                <span>
                  @if (
                    (createForm.controls["ticketType"].errors?.required && createForm.controls["ticketType"].dirty) || !createForm.controls["ticketType"].value
                  ) {
                    <span class="text-danger" style="font-size: 12px; margin-top: -14px !important">
                      <!-- {{'mandatory' | translate}} -->
                    </span>
                  }
                </span>
              }
            </p>
            <p-select
              #ticketty
              [options]="templateList"
              formControlName="ticketType"
              filter="true"
              (onChange)="onChangeTaskType($event)"
              (onShow)="ticketty.resetFilter()"
              optionLabel="name"
              placeholder="{{ 'selectTemplateType' | translate }}"
              styleClass="setUserClassSetType"
              appendTo="body"
              panelStyleClass="template-type-panel"></p-select>
          </div>
        }

        <!-- Div for dynamic template -->
        @if (noBusinessAssigned) {
          <div class="col-lg-12 col-md-12 col-sm-12" style="padding-left: 0px; padding-right: 5px; width: 99% !important">
            @for (data of dynamicJson; track data; let i = $index; let even = $even) {
              <div [ngClass]="[dynamicJson[i].datatype == 'textarea' ? 'dynamicFieldDivNew' : 'dynamicFieldDiv']">
                <div>
                  <p class="formLabel mb-0 commonhead commonBottom" style="font-size: 14px">
                    {{ data.parameterName | translate }}
                    @if (data.isMandatory) {
                      <span style="color: red">*</span>
                    }
                    @if (data?.isValidatedExp == false) {
                      <span style="color: red; font-size: 10px">Field value not valid.</span>
                    }
                  </p>
                  @if (!dynamicJson[i].isMandatory) {
                    @if (dynamicJson[i].datatype == "text") {
                      <input
                        type="text"
                        [(ngModel)]="data.parameterValue"
                        maxlength="45"
                        [ngModelOptions]="{ standalone: true }"
                        class="form-control"
                        id="data{{ i }}"
                        name="data{{ i }}"
                        #uname
                        style="
                          height: 23px;
                          width: 100%;
                          display: inline;
                          padding-left: 6px !important;
                          font-size: 13px !important;
                          color: #333333;
                          border: 1px solid #c8c8c8;
                        "
                        (keyup)="validateNonMandatoryPatternFields(uname.value, i)"
                        pTooltip="{{ data.parameterValue }}"
                        tooltipPosition="top" />
                    }
                    @if (dynamicJson[i].datatype == "dropdown") {
                      <p-select
                        [(ngModel)]="dynamicJson[i].selection"
                        [ngModelOptions]="{ standalone: true }"
                        [options]="dynamicJson[i].dropNewValue"
                        optionLabel="name"
                        placeholder="{{ 'select' | translate }}"
                        appendTo="body"></p-select>
                    }
                    @if (dynamicJson[i].datatype == "employee") {
                      <p-select
                        filter="true"
                        [(ngModel)]="dynamicJson[i].selectionEmp"
                        [ngModelOptions]="{ standalone: true }"
                        [options]="dynamicJson[i].dropNewValue"
                        optionLabel="name"
                        placeholder="{{ 'select' | translate }}"
                        appendTo="body"></p-select>
                    }
                    @if (dynamicJson[i].datatype == "textarea") {
                      <textarea
                        #lname
                        [(ngModel)]="data.parameterValue"
                        class="form-control"
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          height: 70px;
                          width: 100%;
                          display: inline;
                          padding-left: 6px !important;
                          font-size: 13px !important;
                          color: #333333;
                          border: 1px solid #c8c8c8;
                          border-radius: 5px;
                        "
                        (keyup)="validateNonMandatoryPatternFields(lname.value, i)"></textarea>
                    }
                  }
                  @if (dynamicJson[i].isMandatory) {
                    @if (dynamicJson[i].datatype == "text") {
                      <input
                        type="text"
                        class="textField"
                        [(ngModel)]="data.parameterValue"
                        class="form-control"
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          height: 23px;
                          width: 100%;
                          display: inline;
                          padding-left: 6px !important;
                          font-size: 13px !important;
                          color: #333333;
                          border: 1px solid #c8c8c8;
                        "
                        maxlength="45"
                        name="dynamicName{{ i }}"
                        id="data{{ i }}"
                        (keyup)="validateMandatoryFields($event, i, 'text')"
                        pTooltip="{{ data.parameterValue }}"
                        tooltipPosition="top" />
                    }
                    @if (dynamicJson[i].datatype == "dropdown") {
                      <p-select
                        [(ngModel)]="dynamicJson[i].selection"
                        [ngModelOptions]="{ standalone: true }"
                        [options]="dynamicJson[i].dropNewValue"
                        (onChange)="validateMandatoryFields($event, i, 'text')"
                        optionLabel="name"
                        optionValue="name"
                        placeholder="{{ 'select' | translate }}"
                        appendTo="body"></p-select>
                    }
                    @if (dynamicJson[i].datatype == "employee") {
                      <p-select
                        filter="true"
                        [(ngModel)]="dynamicJson[i].selectionEmp"
                        [ngModelOptions]="{ standalone: true }"
                        [options]="dynamicJson[i].dropNewValue"
                        optionLabel="name"
                        (onChange)="validateMandatoryFields($event, i, 'text')"
                        placeholder="{{ 'select' | translate }}"
                        appendTo="body"></p-select>
                    }
                    @if (dynamicJson[i].datatype == "textarea") {
                      <textarea
                        id="w3review"
                        name="w3review"
                        (keyup)="validateMandatoryFields($event, i, 'textarea')"
                        [(ngModel)]="data.parameterValue"
                        class="form-control"
                        [ngModelOptions]="{ standalone: true }"
                        style="
                          height: 70px;
                          width: 100%;
                          display: inline;
                          padding-left: 6px !important;
                          font-size: 13px !important;
                          color: #333333;
                          border: 1px solid #c8c8c8;
                          border-radius: 5px;
                        "></textarea>
                    }
                  }
                </div>
              </div>
            }
          </div>
        }

        <!-- ===== 2-column grid section (Due Date, Assign To, Task Type, Checklist/File) ===== -->
        <div class="create-task-grid">
          <!-- Row 1 Left: Due Date label + Calendar input only -->
          <div
            class="grid-col-left calender"
            style="margin-top: 10px !important; margin-bottom: 8px !important; display: flex; align-items: center; flex-wrap: nowrap">
            <p class="commonhead DuedateHead widthTitle dueDateMultiLang" style="flex-shrink: 0; margin: 0 8px 0 0" title="{{ 'dueDate' | translate }}">
              {{ "dueDate" | translate }}
            </p>
            <p-datepicker
              id="dueDateAdd"
              formControlName="dueDate"
              styleClass="dateFieldAdd"
              placeholder="{{ 'calendar' | translate }}"
              [minDate]="minDueDate"
              [class.selectedBtn]="selectedBtn == 'DATE'"
              (click)="onDateBtnClick('DATE')"
              (onClose)="onCloseDueDate($event)"
              appendTo="body"></p-datepicker>
          </div>

          <!-- Row 1 Right: Quick date buttons + Estimate Hrs -->
          <div
            class="grid-col-right calender"
            style="margin-top: 10px !important; margin-bottom: 8px !important; display: flex; align-items: center; flex-wrap: wrap; gap: 1rem">
            @if (lang != "fr") {
              <button
                [class.selectedBtn]="selectedBtn == 'Today'"
                type="button"
                class="btn btn-default btnStyles"
                (click)="onDateBtnClick('Today')"
                aria-label="Today">
                <b>{{ "today" | translate }}</b>
              </button>
            }
            @if (lang != "fr") {
              <button
                [class.selectedBtn]="selectedBtn == 'Tomorrow'"
                type="button"
                class="btn btn-default btnStyles"
                (click)="onDateBtnClick('Tomorrow')"
                aria-label="Tomorrow">
                <b>{{ "tomorrow" | translate }}</b>
              </button>
            }
            @if (lang != "fr") {
              <button
                [class.selectedBtn]="selectedBtn == 'This Week'"
                type="button"
                class="btn btn-default btnStyles"
                (click)="onDateBtnClick('This Week')"
                aria-label="thisWeek">
                <b>{{ "thisWeek" | translate }}</b>
              </button>
            }
            @if (lang != "fr") {
              <button
                [class.selectedBtn]="selectedBtn == 'Recurrence'"
                type="button"
                (click)="openRecurrence()"
                class="btn btn-default btnStyles"
                aria-label="recurrence">
                <i class="fas fa-redo-alt" style="margin-right: 3px"></i>
                <b>{{ "recurrence" | translate }}</b>
              </button>
            }

            @if (lang == "fr") {
              <button [class.selectedBtn]="selectedBtn == 'Today'" type="button" class="btn btn-default btnStyles" (click)="onDateBtnClick('Today')">
                <b>{{ "today" | translate }}</b>
              </button>
            }
            @if (lang == "fr") {
              <button [class.selectedBtn]="selectedBtn == 'Tomorrow'" type="button" class="btn btn-default btnStyles" (click)="onDateBtnClick('Tomorrow')">
                <b>{{ "tomorrow" | translate }}</b>
              </button>
            }
            @if (lang == "fr") {
              <button [class.selectedBtn]="selectedBtn == 'This Week'" type="button" class="btn btn-default btnStyles" (click)="onDateBtnClick('This Week')">
                <b>{{ "thisWeek" | translate }}</b>
              </button>
            }
            @if (lang == "fr") {
              <button [class.selectedBtn]="selectedBtn == 'Recurrence'" type="button" (click)="openRecurrence()" class="btn btn-default btnStyles">
                <i class="fas fa-redo-alt" style="margin-right: 3px"></i>
                <b>{{ "recurrence" | translate }}</b>
              </button>
            }

            @if (isCreateRecurrence == true) {
              <span class="recMsgSpan" style="width: 100%">{{ "recurrence" | translate }}: {{ recurrenceMsg }}</span>
            }

            <div style="display: flex; align-items: center; gap: 4px; flex-shrink: 0; margin-left: 4px">
              <p class="commonhead assignLabels" style="margin: 0; white-space: nowrap; flex-shrink: 0">{{ "estimate" | translate }}</p>
              <input
                type="number"
                value="1"
                formControlName="dueTime"
                class="inputEstimate"
                min="1"
                max="10"
                oninput="validity.valid || (value = '')"
                placeholder=""
                id="estimateAdd"
                style="width: 48px; flex-shrink: 0" />
              <p class="commonhead assignLabels" style="margin: 0; white-space: nowrap; flex-shrink: 0">{{ "hrs" | translate }}</p>
            </div>
          </div>

          <!-- Row 2 Left: Assign To (Self + Select User) -->
          <div
            class="grid-col-left assign"
            [ngClass]="{ ifrecMsg: isCreateRecurrence == true }"
            style="margin-bottom: 12px; display: flex; align-items: center; flex-wrap: nowrap">
            <p class="commonhead assignLabels widthTitle overflowEllipsisCss" style="margin-right: 8px; flex-shrink: 0" title="{{ 'assignTo' | translate }}">
              {{ "assignTo" | translate }}
            </p>
            <button
              type="button"
              [class.selectedBtn]="selectedBtns == 'self'"
              class="btn btn-default btnStylesss"
              (click)="onselfClick('self')"
              style="flex-shrink: 0">
              <b>{{ "self" | translate }}</b>
            </button>
            <p-select
              #assigndd
              [options]="UserList"
              filter="true"
              [disabled]="setAssigneeGroupFlag"
              formControlName="selectedAssignTo"
              (onShow)="assigndd.resetFilter()"
              placeholder="{{ 'selectUser' | translate }}"
              (onChange)="setAssignee($event.value)"
              optionLabel="name"
              styleClass="setUserClassNew"
              appendTo="body"
              panelStyleClass="assign-to-dropdown-panel"></p-select>
          </div>

          <!-- Row 2 Right: Select User Group -->
          <div class="grid-col-right assign" style="margin-bottom: 12px; display: flex; align-items: center">
            <p-select
              #assigndgroupd
              placeholder="{{ 'selectUserGroup' | translate }}"
              [options]="UserGroupList"
              styleClass="setUserClassSetTypeUserNewe"
              filter="true"
              [disabled]="setAssigneeFlag"
              formControlName="selectedAssignGroup"
              (onChange)="setAssigneeGroup($event.value)"
              (onShow)="assigndgroupd.resetFilter()"
              optionLabel="name"
              [ngClass]="{ userGroupDropdownMulti: lang == 'fr' }"
              appendTo="body"
              panelStyleClass="select-user-group-dropdown-panel"></p-select>
          </div>

          <!-- Row 3 Left: Task Type -->
          <div class="grid-col-left fileupload" style="height: auto; display: flex; align-items: center; margin-bottom: 4px">
            <p class="commonhead commonBottom" style="width: 141px; display: inline-block; margin-right: 8px !important; margin-bottom: 0; flex-shrink: 0">
              {{ "taskType" | translate }}
              <span class="text-danger">*</span>
              @if (createForm.controls["taskType"].errors) {
                <span>
                  @if ((createForm.controls["taskType"].errors?.required && createForm.controls["taskType"].dirty) || !createForm.controls["taskType"].value) {
                    <span class="text-danger" style="font-size: 12px; margin-top: -14px !important">
                      <!-- {{'mandatory' | translate}} -->
                    </span>
                  }
                </span>
              }
            </p>
            <p-select
              #taskdd
              [options]="taskTypeData"
              formControlName="taskType"
              filter="true"
              (onShow)="taskdd.resetFilter()"
              optionLabel="name"
              placeholder="{{ 'selectTaskType' | translate }}"
              styleClass="setUserClassSetType"
              appendTo="body"
              panelStyleClass="tasktype-dropdown-panel"></p-select>
          </div>

          <!-- Row 3 Right: Watchlist -->
          <div
            class="grid-col-right fileupload watchListAddDiv"
            style="height: auto; display: flex; align-items: center; flex-wrap: nowrap; margin-bottom: 4px">
            <p
              class="commonhead taskTypeLabelTs widthTitle overflowEllipsisCss"
              style="width: 80px !important; flex-shrink: 0; margin-bottom: 0"
              title="{{ 'watchlist' | translate }}">
              {{ "watchlist" | translate }}
            </p>
            <p-multiselect
              (onChange)="onChangeWathlist($event)"
              [options]="watchlistDropdown"
              placeholder="{{ 'selectWatchlist' | translate }}"
              formControlName="selectWatchlist"
              styleClass="widthdropdownProjectMultiselect"
              [ngClass]="{ watchListMulti: lang == 'fr' }"
              appendTo="body"
              panelStyleClass="select-watchlist-dropdown-panel"></p-multiselect>
          </div>

          <!-- Row 4 Left: Add checklist -->
          <div class="grid-col-left" style="align-items: flex-start">
            <div class="assign mbottom" style="margin-left: 0">
              <p>
                <img src="../../../../assets/img/Group8434.png" style="width: 15px; cursor: pointer" (click)="addNewRow()" alt="checklist" />
                {{ "addchecklist" | translate }}
              </p>
              <div class="checklist-scroll-container">
                <form [formGroup]="invoiceForm">
                  <div formArrayName="checklist" style="margin-top: 10px">
                    @for (itemrow of invoiceForm.controls.checklist.controls; track itemrow; let i = $index) {
                      <div [formGroupName]="i">
                        <div style="display: inline-block; height: 9px">
                          <div class="form-group" style="width: 10px; display: inline-block; margin-right: 5px; height: 26px; vertical-align: sub">
                            <input
                              formControlName="checked"
                              class="form-control"
                              type="checkbox"
                              id="checkListAdd"
                              style="display: inline-block; width: 20px; height: 16px; border-radius: 10px; cursor: pointer" />
                          </div>
                          <div class="form-group" style="width: 300px; display: inline-block; margin-bottom: 5px; margin-right: 15px">
                            <input
                              formControlName="criteria"
                              class="form-control inputclass"
                              id="criteriaAdd"
                              style="
                                height: 21px;
                                margin-bottom: 5px !important;
                                margin-left: 9px;
                                margin-bottom: 7px;
                                margin-top: 5px;
                                display: inline-block;
                              " />
                          </div>
                        </div>
                        @if (invoiceForm.controls.checklist.controls.length > 0) {
                          <img
                            (click)="deleteRow(i)"
                            src="../../../../assets/img/close.png"
                            alt="delete"
                            style="display: inline-block; width: 15px; cursor: pointer" />
                        }
                      </div>
                    }
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!-- Row 4 Right: Choose File -->
          <div class="grid-col-right btnmozilla">
            <input
              type="button"
              style="margin-top: 8px"
              class="btn btn-sm attachfilebtn"
              name="attachfile"
              id="attachfile"
              (click)="uploader.click()"
              value="{{ 'chooseFile' | translate }}" />
            <input hidden type="file" (click)="uploader.value = null" (change)="onFileChange($event)" class="file" id="addattachfile" #uploader multiple />
            <label class="fileSizeLabel mb-0 ml-1 fileSizeMsgMulti" for="addattachfile" style="width: 200px">
              <span class="text-danger">*</span>
              Max file size: 30 MB per file.
            </label>

          
          </div>
          <div class=" grid-col-right btnmozilla" style=" min-height: 40px; ">
            @if (files && files.length > 0) {
              
                @for (files of files; track files; let index = $index) {
                  <div class="attachmentRow">
                    <img class="attachedImg" [src]="getFileIcon(files)" [title]="files.fileName" style="width: 26px; flex-shrink: 0" alt="file" />
                    <!-- <span class="attachmentFileName" [title]="files.fileName">{{ files.fileName }}</span> -->
                    <img
                      (click)="removeSelectedFile(index)"
                      src="../../../../assets/img/close.png"
                      alt="remove"
                      style="width: 15px;
    display: inline-block;
    margin-left: -13px;
    cursor: pointer;
    margin-bottom: 21px;"/>
                  </div>
                }
              }
              </div>
           
        </div>
        <!-- ===== end 2-column grid section ===== -->
      </form>
    </ng-template>
  </p-scrollpanel>

  <div class="create-task-footer">
    <button type="button" class="btn btn-default submitBtns" (click)="CancelCreateForm()">
      {{ "cancel " | translate }}
    </button>
    <button
      type="button"
      class="btn btn-default submitBtnDash"
      [disabled]="!createForm.valid || isValidDesc == true || isValidDesc1 == true || !isValidatedManField || !isValidatedNonManField"
      (click)="createForm.valid && !isValidDesc && !isValidDesc1 && isValidatedManField && isValidatedNonManField ? CreateTask(createForm.value) : null"
      style="cursor: pointer">
      {{ "createBTN" | translate }}
    </button>
  </div>
</p-dialog>

<p-dialog [(visible)]="viewDialogueBox" [closable]="false" styleClass="view-task-new-dialog" [modal]="true" [draggable]="false">
  @if (headerNameData == "View Task") {
    <div class="view-task-dialog-title">
      {{ "viewTask" | translate }} - {{ taskIdData }}
      <i (click)="CancelViewForm()" class="pi pi-times close-icon"></i>
    </div>
  }
  @if (headerNameData == "Edit Task") {
    <div class="view-task-dialog-title">
      {{ "editTask" | translate }} - {{ taskIdData }}
      <i (click)="CancelViewForm()" class="pi pi-times close-icon"></i>
    </div>
  }

  <div class="view-task-container .container-fluid">
    <form [formGroup]="viewForm">
      <div class="row m-0 view-task-row">
        <!-- Details Section -->

        <div
          class="view-cols detail-col"
          [ngClass]="{
            'col-6': expandedCol == 'Detail',
            'col-3': expandedCol == '',
            'col-2': expandedCol != '' && expandedCol != 'Detail',
          }">
          <div class="col-card first">
            <div class="col-header">
              <span class="pl-1">Details</span>
              @if (expandedCol != "Detail") {
                <i class="pi pi-window-maximize" pTooltip="Maximize" (click)="onMaxWindowClick('Detail')"></i>
              }
              @if (expandedCol == "Detail") {
                <i class="pi pi-window-minimize" pTooltip="Minimize" (click)="onMaxWindowClick('')"></i>
              }
            </div>
            <div class="task-content">
              <div class="row m-0 mt-2">
                <div class="col-12 p-0">
                  <!-- Section for Private Task -->
                  @if (isPrivateTaskData) {
                    <div class="form-group form-inline taskName" [ngClass]="{ widthIncrease: isPrivateTaskData }">
                      <div class="col-12 col-md-12 col-lg-8 p-0 m-0">
                        @if (viewFormDisabled) {
                          <input
                            type="text"
                            pInputText
                            class="form-control taskNameInput w-100"
                            id="taskNameEdit"
                            maxlength="500"
                            [class.invalid]="!this.viewForm.valid"
                            readonly
                            placeholder="{{ 'addTaskName500Char' | translate }}*"
                            formControlName="taskName"
                            name="taskName" />
                        }
                        @if (!viewFormDisabled) {
                          <input
                            type="text"
                            pInputText
                            class="form-control taskNameInput"
                            id="taskNameEdit1"
                            maxlength="500"
                            [class.invalid]="!this.viewForm.valid"
                            placeholder="{{ 'addTaskName500Char' | translate }}*"
                            formControlName="taskName"
                            name="taskName" />
                        }
                      </div>
                      <div class="col-12 col-md-12 col-lg-4 p-0 m-0 d-flex justify-content-md-end">
                        @if (!onEditClickCheck) {
                          <p-checkbox
                            name="privateTask"
                            binary="true"
                            inputId="privateTaskView1"
                            class="privateSpanView"
                            formControlName="privateTask"
                            disabled="true"></p-checkbox>
                          <label for="privateTaskView1" class="ml-2">{{ "privateTask" | translate }}</label>
                          <p-checkbox
                            name="privateTask"
                            binary="true"
                            inputId="privateTaskView2"
                            class="privateSpanView"
                            formControlName="privateTask"
                            disabled="true"></p-checkbox>
                          <label for="privateTaskView2" class="ml-2">{{ "privateTask" | translate }}</label>
                        }
                        @if (privateTaskAllow && onEditClickCheck) {
                          <p-checkbox
                            name="privateTask"
                            binary="true"
                            inputId="privateTaskView3"
                            class="privateSpanView"
                            formControlName="privateTask"></p-checkbox>
                          <label for="privateTaskView3" class="ml-2">{{ "privateTask" | translate }}</label>
                        }
                      </div>
                    </div>
                  }

                  <!-- Section for Non-Private Task -->
                  @if (!isPrivateTaskData) {
                    <div class="form-group form-inline taskName" [ngClass]="{ widthIncrease: !isPrivateTaskData }">
                      <div class="col-12 col-md-12 col-lg-8 p-0 m-0">
                        @if (viewFormDisabled) {
                          <input
                            type="text"
                            pInputText
                            class="form-control taskNameInput"
                            id="taskNameEdit2"
                            maxlength="500"
                            [class.invalid]="!this.viewForm.valid"
                            readonly
                            placeholder="{{ 'addTaskName500Char' | translate }}*"
                            formControlName="taskName"
                            name="taskName" />
                        }
                        @if (!viewFormDisabled) {
                          <input
                            type="text"
                            pInputText
                            class="form-control taskNameInput"
                            id="taskNameEdit3"
                            maxlength="500"
                            [class.invalid]="!this.viewForm.valid"
                            placeholder="{{ 'addTaskName500Char' | translate }}*"
                            formControlName="taskName"
                            name="taskName" />
                        }
                      </div>
                      <div class="col-12 col-md-12 col-lg-4 p-0 m-0 d-flex justify-content-end w-fit">
                        @if (viewFormDisabled) {
                          <p-checkbox
                            name="privateTask"
                            binary="true"
                            inputId="privateTaskView4"
                            class="privateSpanView"
                            formControlName="privateTask"
                            disabled="true"></p-checkbox>
                          <label for="privateTaskView4">{{ "privateTask" | translate }}</label>
                        }
                        @if (!viewFormDisabled) {
                          <p-checkbox
                            name="privateTask"
                            binary="true"
                            inputId="privateTaskView5"
                            class="privateSpanView"
                            formControlName="privateTask"></p-checkbox>
                          <label for="privateTaskView5">{{ "privateTask" | translate }}</label>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>

              <div class="row m-0 mt-1">
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 pl-md-1 pl-lg-1 pr-lg-0 pl-0 pr-0">
                  <div class="productSelectionNew">
                    <p class="commonhead commonBottom">
                      {{ "selectProduct" | translate }}
                    </p>
                    <p-select
                      #dd
                      [options]="product"
                      filter="true"
                      appendTo="body"
                      formControlName="selectedProduct"
                      class="widthdropdownProject"
                      placeholder="{{ 'selectProduct' | translate }}"
                      (onShow)="dd.resetFilter()"
                      optionLabel="name"
                      [readonly]="viewFormDisabled"></p-select>
                  </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 pl-md-1 pl-lg-1 pr-0">
                  <div class="projectSelectionViewNew">
                    <p class="commonhead commonBottom">
                      {{ "selectProject" | translate }}
                    </p>
                    <p-select
                      #projectdd
                      [options]="projects"
                      filter="true"
                      appendTo="body"
                      (onShow)="projectdd.resetFilter()"
                      formControlName="selectedProject"
                      optionLabel="name"
                      [readonly]="viewFormDisabled"
                      class="widthdropdownProject"
                      placeholder="{{ 'selectProject' | translate }}"></p-select>
                  </div>
                </div>
              </div>
              <div class="row m-0 mt-1">
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 pl-md-1 pl-lg-1 pr-lg-0 pl-0 pr-0">
                  <div class="productSelectionNew">
                    <p class="commonhead commonBottom">
                      {{ "selectPriority" | translate }}
                    </p>
                    <p-select
                      #prioritydd
                      [options]="priority"
                      formControlName="selectedPriority"
                      appendTo="body"
                      filter="false"
                      placeholder="{{ 'selectPriority' | translate }}"
                      class="widthdropdownProject"
                      optionLabel="name"
                      [readonly]="viewFormDisabled"></p-select>
                  </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 pl-md-1 pl-lg-1 pr-0">
                  <div class="projectSelectionViewNew">
                    <p class="commonhead commonBottom">
                      {{ "status" | translate }}
                    </p>
                    <p-select
                      #statusdd
                      [options]="StatusList"
                      optionLabel="name"
                      formControlName="Status"
                      appendTo="body"
                      filter="true"
                      (onChange)="openCommentBox($event.value)"
                      class="widthdropdownProject"
                      placeholder="{{ 'selectStatus' | translate }}"
                      [readonly]="viewFormDisabled"></p-select>
                  </div>
                </div>
              </div>
              @if (isStatusSelected) {
                <div class="row m-0 mt-1 invalid-feedback pl-1" style="width: 315px; font-size: 12px !important">
                  {{ "commentIsMandatoryForSelectedStatus" | translate }} {{ showSelectedStatus }} {{ "status" | translate }}.
                </div>
              }
              <div class="row m-0 mt-1">
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 pl-md-1 pl-lg-1 pr-0" style="padding-left: 4px">
                  <p class="commonhead taskTypeLabelTs widthTitle overflowEllipsisCss" title="{{ 'taskType' | translate }}">
                    {{ "taskType" | translate }}
                  </p>
                  <p-select
                    #taskdd
                    [options]="taskTypeData"
                    formControlName="taskType"
                    filter="true"
                    appendTo="body"
                    placeholder="{{ 'selectTaskType' | translate }}"
                    (onShow)="taskdd.resetFilter()"
                    class="widthdropdownProject"
                    optionLabel="name"
                    [readonly]="viewFormDisabled"></p-select>
                </div>
              </div>
              <!--  <div class="container-fluid p-0 m-0"> -->
              <!-- First Row: Calendar and Buttons -->
              <div class="row m-0 mt-1">
                <!-- Calendar Section -->
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 pl-md-1 pl-lg-1 pr-lg-0 pr-0">
                  <p class="commonhead DuedateHead widthTitle dueDateMultiLang me-3" title="{{ 'dueDate' | translate }}">
                    {{ "dueDate" | translate }}
                  </p>
                  <p-datepicker
                    id="dueDateEdit"
                    formControlName="dueDate"
                    dateFormat="mm/dd/yy"
                    styleClass="dateField"
                    [minDate]="viewFormDisabled ? null : minDueDate"
                    [keepInvalid]="true"
                    [class.selectedBtn]="selectedBtn == 'DATE'"
                    (click)="!viewFormDisabled && onDateBtnClickview('DATE')"
                    (onSelect)="currentDueDate = $event"
                    (onClose)="onCloseDueDate($event)"
                    (onShow)="highlightSelectedDate()"
                    [readonlyInput]="viewFormDisabled"
                    [showOnFocus]="!viewFormDisabled"
                    appendTo="body"></p-datepicker>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-6 d-flex flex-row flex-wrap flex-column pl-md-1 pl-lg-1 m-0 pr-0">
                  <!-- Estimate Label -->
                  <p class="commonhead assignLabels widthTitle me-3">
                    {{ "estimate" | translate }}
                  </p>
                  <div class="estimate-input">
                    <!-- Estimate Input -->
                    @if (viewFormDisabled) {
                      <input
                        type="number"
                        formControlName="dueTime"
                        class="form-control me-2 inputEstimateNew w-lg-100 w-sm-100"
                        min="1"
                        max="10"
                        oninput="validity.valid || (value = '')"
                        [disabled]="viewFormDisabled"
                        id="estimateEdit"
                        readonly />
                    }
                    @if (!viewFormDisabled) {
                      <input
                        type="number"
                        formControlName="dueTime"
                        class="form-control me-2 inputEstimateNew"
                        min="1"
                        max="10"
                        oninput="validity.valid || (value = '')"
                        [disabled]="viewFormDisabled"
                        id="editEstimate" />
                    }

                    <!-- Estimate Unit -->
                    <p class="commonhead assignLabels" style="display: inline-block">
                      {{ "hrs" | translate }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Second Row: Recurrence Button, Recurrence Message, Estimate -->
              <div class="row m-0 mt-1">
                <button
                  [class.selectedBtn]="selectedBtn == 'Today'"
                  type="button"
                  class="btn btn-default btnStylesview flex-grow-1 me-2 mr-1"
                  (click)="onDateBtnClickview('Today')"
                  [disabled]="viewFormDisabled">
                  <b>{{ "today" | translate }}</b>
                </button>
                <button
                  [class.selectedBtn]="selectedBtn == 'Tomorrow'"
                  type="button"
                  class="btn btn-default btnStylesview flex-grow-1 me-2 mr-1"
                  (click)="onDateBtnClickview('Tomorrow')"
                  [disabled]="viewFormDisabled">
                  <b>{{ "tomorrow" | translate }}</b>
                </button>
                <button
                  [class.selectedBtn]="selectedBtn == 'This Week'"
                  type="button"
                  class="btn btn-default btnStylesview flex-grow-1 mr-1"
                  (click)="onDateBtnClickview('This Week')"
                  [disabled]="viewFormDisabled">
                  <b>{{ "thisWeek" | translate }}</b>
                </button>
                <button
                  [class.selectedBtn]="selectedBtn == 'Recurrence'"
                  type="button"
                  class="btn btn-default btnStylesviewNew flex-grow-1 me-2 mr-1"
                  (click)="openRecurrence()"
                  [disabled]="viewFormDisabled">
                  <i class="fas fa-redo-alt mr-1"></i>
                  <b>{{ "recurrence" | translate }}</b>
                </button>
              </div>
              <!-- </div> -->

              @if (isPrivateTaskData) {
                <div class="assign row m-0 mt-1" [ngClass]="{ ifrecMsg: isCreateRecurrence == true }">
                  <div class="col-sm-12 col-md-12 col-lg-2 mr-md-3 p-0 pr-md-2">
                    <p class="commonhead assignLabels widthTitle overflowEllipsisCss" style="margin-right: 0px" title="{{ 'assignTo' | translate }}">
                      {{ "assignTo" | translate }}
                    </p>
                    <button
                      type="button"
                      [class.selectedBtn]="selectedBtns == 'self'"
                      class="btn btn-default btnStylesss m-0 mr-0"
                      (click)="onselfClickEdit('self')"
                      [disabled]="viewFormDisabled">
                      <b>{{ "self" | translate }}</b>
                    </button>
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-5 p-0 pl-1" style="margin-top: 1.3rem">
                    <p-select
                      #assigndd
                      [options]="UserList"
                      filter="true"
                      [disabled]="setAssigneeGroupFlag"
                      appendTo="body"
                      formControlName="selectedAssignTo"
                      (onShow)="assigndd.resetFilter()"
                      class="widthdropdownProject"
                      placeholder="{{ 'selectUser' | translate }}"
                      (onChange)="setAssignee($event.value)"
                      optionLabel="name"
                      [readonly]="viewFormDisabled"></p-select>
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-5 p-0 w-100 pl-1" style="margin-top: 1.3rem">
                    <p-select
                      #assigndgroupd
                      [options]="UserGroupList"
                      filter="true"
                      appendTo="body"
                      [disabled]="setAssigneeFlag"
                      formControlName="selectedAssignGroup"
                      class="widthdropdownProject"
                      (onShow)="assigndgroupd.resetFilter()"
                      placeholder="{{ 'selectUserGroup' | translate }}"
                      (onChange)="setAssignee($event.value)"
                      optionLabel="name"
                      [readonly]="viewFormDisabled"></p-select>
                  </div>
                </div>
              }

              @if (!isPrivateTaskData) {
                <div class="assign row m-0 mt-1" [ngClass]="{ ifrecMsg: isCreateRecurrence == true }">
                  <div class="col-sm-12 col-md-12 col-lg-2 pl-md-1 pl-lg-1 pr-0 m-0 pr-md-0" style="padding-right: 4px !important">
                    <p class="commonhead assignLabels widthTitle overflowEllipsisCss" style="margin-right: 0px" title="{{ 'assignTo' | translate }}">
                      {{ "assignTo" | translate }}
                    </p>
                    @if (!onEditClickCheck) {
                      <button
                        type="button"
                        [class.selectedBtn]="selectedBtns == 'self'"
                        class="btn btn-default btnStylesss m-0 mr-0"
                        (click)="onselfClickEdit('self')"
                        [disabled]="viewFormDisabled">
                        <b>{{ "self" | translate }}</b>
                      </button>
                    }
                    @if (!privateTaskAllow && onEditClickCheck) {
                      <button
                        type="button"
                        [class.selectedBtn]="selectedBtns == 'self'"
                        class="btn btn-default btnStylesss m-0 mr-0"
                        (click)="onselfClickEdit('self')"
                        [disabled]="viewFormDisabled">
                        <b>{{ "self" | translate }}</b>
                      </button>
                    }
                    @if (privateTaskAllow && onEditClickCheck) {
                      <button
                        type="button"
                        [class.selectedBtn]="selectedBtns == 'self'"
                        class="btn btn-default btnStylesss"
                        (click)="onselfClickEdit('self')"
                        [disabled]="viewFormDisabled">
                        <b>{{ "self" | translate }}</b>
                      </button>
                    }
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-5 pl-md-1 pl-lg-1 pr-0" style="margin-top: 1.3rem">
                    @if (!onEditClickCheck) {
                      <p-select
                        #assigndd
                        [options]="UserList"
                        filter="true"
                        appendTo="body"
                        [disabled]="true"
                        formControlName="selectedAssignTo"
                        (onShow)="assigndd.resetFilter()"
                        class="widthdropdownProject"
                        placeholder="{{ 'selectUser' | translate }}"
                        (onChange)="setAssignee($event.value)"
                        optionLabel="name"
                        [readonly]="viewFormDisabled"></p-select>
                    }
                    @if (!privateTaskAllow && onEditClickCheck) {
                      <p-select
                        #assigndd
                        [options]="UserList"
                        filter="true"
                        appendTo="body"
                        [disabled]="true"
                        class="widthdropdownProject"
                        formControlName="selectedAssignTo"
                        (onShow)="assigndd.resetFilter()"
                        placeholder="{{ 'selectUser' | translate }}"
                        (onChange)="setAssignee($event.value)"
                        optionLabel="name"
                        styleClass="setUserClassView"
                        [readonly]="viewFormDisabled"></p-select>
                    }
                    @if (privateTaskAllow && onEditClickCheck) {
                      <p-select
                        #assigndd
                        [options]="UserList"
                        filter="true"
                        appendTo="body"
                        class="widthdropdownProject"
                        [disabled]="setAssigneeGroupFlag"
                        formControlName="selectedAssignTo"
                        placeholder="{{ 'selectUser' | translate }}"
                        (onShow)="assigndd.resetFilter()"
                        (onChange)="setAssignee($event.value)"
                        optionLabel="name"
                        styleClass="setUserClassView"
                        [readonly]="viewFormDisabled"></p-select>
                    }
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-5 p-0 w-100 pl-md-1 pl-lg-1 pr-0" style="margin-top: 1.3rem">
                    @if (!onEditClickCheck) {
                      <p-select
                        #assigndgroupd
                        [options]="UserGroupList"
                        filter="true"
                        appendTo="body"
                        class="widthdropdownProject"
                        [disabled]="true"
                        placeholder="{{ 'selectUserGroup' | translate }}"
                        formControlName="selectedAssignGroup"
                        (onChange)="setAssigneeGroup($event.value)"
                        (onShow)="assigndgroupd.resetFilter()"
                        optionLabel="name"
                        [readonly]="viewFormDisabled"></p-select>
                    }
                    @if (!privateTaskAllow && onEditClickCheck) {
                      <p-select
                        #assigndgroupd
                        [options]="UserGroupList"
                        appendTo="body"
                        class="widthdropdownProject"
                        filter="true"
                        [disabled]="true"
                        placeholder="{{ 'selectUserGroup' | translate }}"
                        formControlName="selectedAssignGroup"
                        (onChange)="setAssigneeGroup($event.value)"
                        (onShow)="assigndgroupd.resetFilter()"
                        optionLabel="name"
                        [readonly]="viewFormDisabled"></p-select>
                    }
                    @if (privateTaskAllow && onEditClickCheck) {
                      <p-select
                        #assigndgroupd
                        [options]="UserGroupList"
                        appendTo="body"
                        class="widthdropdownProject"
                        styleClass="setUserClassSetTypeUserView"
                        filter="true"
                        [disabled]="setAssigneeFlag"
                        placeholder="{{ 'selectUserGroup' | translate }}"
                        formControlName="selectedAssignGroup"
                        (onChange)="setAssigneeGroup($event.value)"
                        (onShow)="assigndgroupd.resetFilter()"
                        optionLabel="name"
                        [readonly]="viewFormDisabled"></p-select>
                    }
                  </div>
                </div>
              }
              <!-- Div for dynamic template -->
              @if (multipleTemplateList) {
                <div class="col-lg-12 col-md-12 col-sm-12 ticketType mt-1" style="padding-left: 5px; padding-right: 5px; margin-bottom: 4px">
                  <p class="commonhead commonBottom" style="width: 130px; margin-right: 8px !important">
                    {{ "templateType" | translate }}
                    @if (viewForm.controls["ticketType"].errors) {
                      <span>
                        @if (
                          (viewForm.controls["ticketType"].errors?.required && viewForm.controls["ticketType"].dirty) || !viewForm.controls["ticketType"].value
                        ) {
                          <span class="text-danger" style="font-size: 12px; margin-top: -14px !important">
                            <!-- {{'mandatory' | translate}} -->
                          </span>
                        }
                      </span>
                    }
                  </p>
                  <p-select
                    #ticketty1
                    [options]="templateList"
                    formControlName="ticketType"
                    filter="true"
                    (onChange)="onChangeTaskTypeEdit($event)"
                    (onShow)="ticketty1.resetFilter()"
                    optionLabel="name"
                    placeholder="{{ 'selectTemplateType' | translate }}"
                    styleClass="setUserClassSetType"
                    [readonly]="viewFormDisabled"
                    appendTo="body"></p-select>
                </div>
              }
              @if (noBusinessAssigned) {
                <div class="col-lg-12 col-md-12 col-sm-12" style="padding-left: 5px; padding-right: 5px; width: 99% !important">
                  @for (data of dynamicJsonEdit; track data; let i = $index; let even = $even) {
                    <div class="mr-1" [ngClass]="[dynamicJsonEdit[i].datatype == 'textarea' ? 'dynamicFieldDivNew' : 'dynamicFieldDiv']">
                      <div>
                        <p class="formLabel mb-0 commonhead commonBottom" style="font-size: 14px">
                          {{ data.parameterName | translate }}
                          @if (data.isMandatory) {
                            <span style="color: red">*</span>
                          }
                          @if (data?.isValidatedExp == false) {
                            <span style="color: red; font-size: 10px">Field value not valid.</span>
                          }
                        </p>
                        @if (!dynamicJsonEdit[i].isMandatory) {
                          @if (dynamicJsonEdit[i].datatype == "text") {
                            <input
                              type="text"
                              [(ngModel)]="data.parameterValue"
                              maxlength="45"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control"
                              id="data{{ i }}"
                              name="data{{ i }}"
                              #uname
                              style="
                                height: 23px;
                                width: 100%;
                                display: inline;
                                padding-left: 6px !important;
                                font-size: 13px !important;
                                color: #333333;
                                border: 1px solid #c8c8c8;
                              "
                              (keyup)="validateNonMandatoryPatternFieldsEdit(uname.value, i)"
                              pTooltip="{{ data.parameterValue }}"
                              tooltipPosition="top"
                              [disabled]="viewFormDisabled" />
                          }
                          @if (dynamicJsonEdit[i].datatype == "dropdown") {
                            <p-select
                              [(ngModel)]="dynamicJsonEdit[i].selection"
                              [ngModelOptions]="{ standalone: true }"
                              [options]="dynamicJsonEdit[i].dropNewValue"
                              optionLabel="name"
                              placeholder="{{ 'select' | translate }}"
                              [readonly]="viewFormDisabled"
                              appendTo="body"></p-select>
                          }
                          @if (dynamicJsonEdit[i].datatype == "employee") {
                            <p-select
                              filter="true"
                              [(ngModel)]="dynamicJsonEdit[i].selectionEmp"
                              [ngModelOptions]="{ standalone: true }"
                              [options]="dynamicJsonEdit[i].dropNewValue"
                              optionLabel="name"
                              placeholder="{{ 'select' | translate }}"
                              [readonly]="viewFormDisabled"
                              appendTo="body"></p-select>
                          }
                          @if (dynamicJsonEdit[i].datatype == "textarea") {
                            <textarea
                              #lname
                              [(ngModel)]="data.parameterValue"
                              class="form-control"
                              [ngModelOptions]="{ standalone: true }"
                              style="
                                height: 70px;
                                width: 330px;
                                display: inline;
                                padding-left: 6px !important;
                                font-size: 13px !important;
                                color: #333333;
                                border: 1px solid #c8c8c8;
                                border-radius: 5px;
                              "
                              (keyup)="validateNonMandatoryPatternFieldsEdit(lname.value, i)"
                              [disabled]="viewFormDisabled"></textarea>
                          }
                        }
                        @if (dynamicJsonEdit[i].isMandatory) {
                          @if (dynamicJsonEdit[i].datatype == "text") {
                            <input
                              type="text"
                              class="textField"
                              [(ngModel)]="data.parameterValue"
                              class="form-control"
                              [ngModelOptions]="{ standalone: true }"
                              style="
                                height: 23px;
                                width: 100%;
                                display: inline;
                                padding-left: 6px !important;
                                font-size: 13px !important;
                                color: #333333;
                                border: 1px solid #c8c8c8;
                              "
                              maxlength="45"
                              name="dynamicName{{ i }}"
                              id="data{{ i }}"
                              (keyup)="validateMandatoryFieldsEdit($event, i, 'text')"
                              pTooltip="{{ data.parameterValue }}"
                              tooltipPosition="top"
                              [disabled]="viewFormDisabled" />
                          }
                          @if (dynamicJsonEdit[i].datatype == "dropdown") {
                            <p-select
                              [(ngModel)]="dynamicJsonEdit[i].selection"
                              [ngModelOptions]="{ standalone: true }"
                              [options]="dynamicJsonEdit[i].dropNewValue"
                              (onChange)="validateMandatoryFieldsEdit($event, i, 'text')"
                              optionLabel="name"
                              placeholder="{{ 'select' | translate }}"
                              [readonly]="viewFormDisabled"
                              appendTo="body"></p-select>
                          }
                          <!-- onChangeDropValue1($event,i) -->
                          @if (dynamicJsonEdit[i].datatype == "employee") {
                            <p-select
                              filter="true"
                              [(ngModel)]="dynamicJsonEdit[i].selectionEmp"
                              [ngModelOptions]="{ standalone: true }"
                              [options]="dynamicJsonEdit[i].dropNewValue"
                              optionLabel="name"
                              (onChange)="validateMandatoryFieldsEdit($event, i, 'text')"
                              placeholder="{{ 'select' | translate }}"
                              [readonly]="viewFormDisabled"
                              appendTo="body"></p-select>
                          }
                          @if (dynamicJsonEdit[i].datatype == "textarea") {
                            <textarea
                              id="w3review"
                              name="w3review"
                              (keyup)="validateMandatoryFieldsEdit($event, i, 'textarea')"
                              [(ngModel)]="data.parameterValue"
                              class="form-control"
                              [ngModelOptions]="{ standalone: true }"
                              style="
                                height: 70px;
                                width: 330px;
                                display: inline;
                                padding-left: 6px !important;
                                font-size: 13px !important;
                                color: #333333;
                                border: 1px solid #c8c8c8;
                                border-radius: 5px;
                              "
                              [disabled]="viewFormDisabled"></textarea>
                          }
                        }
                      </div>
                    </div>
                  }
                </div>
              }
              <div class="row m-0 mt-2">
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 pl-md-1 pl-lg-1 pr-0 pe-md-0">
                  <div class="watchlistDivEdit">
                    <p class="commonhead taskTypeLabelTs widthTitle overflowEllipsisCss" style="margin-left: 10px" title="{{ 'watchlist' | translate }}">
                      {{ "watchlist" | translate }}
                    </p>

                    <p-multiselect
                      [(ngModel)]="dtWatchlistNew"
                      formControlName="selectWatchlists"
                      style="margin-left: 0px !important"
                      (onChange)="onChangeWathlist($event)"
                      [options]="watchlistDropdown"
                      placeholder="{{ 'selectWatchlist' | translate }}"
                      class="widthdropdownProjectMultiselect watchlistdd-new"
                      [readonly]="viewFormDisabled"></p-multiselect>
                  </div>
                </div>
              </div>
              @if (viewFormDisabled) {
                <div class="row m-0 mt-1">
                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-md-1 pl-lg-1 pr-0 pe-md-0">
                    @if (viewFormDisabled && checklist) {
                      <div class="assign mbottom">
                        <p-scrollPanel [style]="{ height: '165px' }" styleClass="mystyle">
                          <form [formGroup]="invoiceForms">
                            <div formArrayName="checklist">
                              <p>
                                <img src="../../../../assets/img/Group8434.png" alt="checklist" style="width: 15px; margin-left: 4px; margin-right: 7px" />
                                {{ "viewChecklist" | translate }}
                              </p>
                              @for (itemrow of invoiceForms.controls.checklist.controls; track itemrow; let i = $index) {
                                <div [formGroupName]="i">
                                  <div style="display: inline-block; height: 9px">
                                    <div
                                      class="form-group"
                                      style="width: 10px; display: inline-block; margin-bottom: 5px; margin-right: 5px; margin-left: 2px; vertical-align: sub">
                                      <input
                                        [disabled]="viewFormDisabled == true"
                                        [attr.readonly]="readonlyAtt"
                                        formControlName="checked"
                                        class="form-control"
                                        type="checkbox"
                                        style="display: inline-block; width: 20px; height: 16px"
                                        disabled />
                                    </div>
                                    <div class="form-group" style="width: 200px; display: inline-block; margin-bottom: 5px; margin-right: 9px">
                                      <input
                                        [attr.readonly]="readonlyAtt"
                                        formControlName="criteria"
                                        class="form-control inputclass"
                                        style="
                                          height: 18px;
                                          margin-bottom: 5px !important;
                                          margin-left: 5px;
                                          margin-bottom: 7px;
                                          margin-top: 5px;
                                          display: inline-block;
                                          width: 337px;
                                          border-width: 0 0 0px;
                                          border-color: #80808061;
                                        " />
                                    </div>
                                  </div>
                                  @if (invoiceForms.controls.checklist.controls.length > 0 && !viewFormDisabled) {
                                    <img
                                      (click)="deleteRowss(i)"
                                      src="../../../../assets/img/close.png"
                                      alt="delete"
                                      alt=""
                                      style="display: inline-block; width: 15px; cursor: pointer" />
                                  }
                                </div>
                              }
                            </div>
                          </form>
                        </p-scrollPanel>
                      </div>
                    }
                  </div>
                </div>
              }

              <!-- Checklist for View -->
              @if (!viewFormDisabled) {
                <div class="row m-0 mt-1">
                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-md-1 pl-lg-1 pr-0 pe-md-0">
                    <div class="assign mbottom">
                      @if (!viewFormDisabled) {
                        <p>
                          <img
                            src="../../../../assets/img/Group8434.png"
                            alt="checklist"
                            style="width: 15px; margin-left: 2px; cursor: pointer; margin-right: 7px"
                            (click)="addNewRows()" />
                          {{ "addchecklist" | translate }}
                        </p>
                      }
                      <p-scrollPanel styleClass="mystyle">
                        <form [formGroup]="invoiceForms">
                          <div formArrayName="checklist">
                            @for (itemrow of invoiceForms.controls.checklist.controls; track itemrow; let i = $index) {
                              <div [formGroupName]="i">
                                <div style="display: inline-block; height: 9px">
                                  <div
                                    class="form-group"
                                    style="width: 10px; display: inline-block; margin-bottom: 5px; margin-right: 5px; vertical-align: sub">
                                    <input
                                      formControlName="checked"
                                      class="form-control"
                                      type="checkbox"
                                      id="checlistEdit"
                                      style="display: inline-block; width: 20px; height: 16px; cursor: pointer" />
                                  </div>
                                  <div class="form-group" style="width: 260px; display: inline-block; margin-bottom: 5px; margin-right: 15px">
                                    <input
                                      formControlName="criteria"
                                      class="form-control inputclass"
                                      id="criteriaEdit"
                                      style="
                                        height: 18px;
                                        margin-bottom: 5px !important;
                                        margin-left: 9px;
                                        margin-bottom: 7px;
                                        margin-top: 5px;
                                        display: inline-block;
                                      " />
                                  </div>
                                </div>
                                @if (invoiceForms.controls.checklist.controls.length > 0 && !viewFormDisabled) {
                                  <img
                                    (click)="deleteRowss(i)"
                                    src="../../../../assets/img/close.png"
                                    alt="close"
                                    alt=""
                                    style="display: inline-block; width: 15px; cursor: pointer" />
                                }
                              </div>
                            }
                          </div>
                        </form>
                      </p-scrollPanel>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <!-- Description and attachments Section -->
        <div
          class="view-cols description-col"
          [ngClass]="{
            'col-6': expandedCol == 'Description',
            'col-3': expandedCol == '',
            'col-2': expandedCol != '' && expandedCol != 'Description',
          }">
          <div class="col-card">
            <div class="col-header">
              <span class="pl-1">Description</span>
              @if (expandedCol != "Description") {
                <i class="pi pi-window-maximize" pTooltip="Maximize" (click)="onMaxWindowClick('Description')"></i>
              }
              @if (expandedCol == "Description") {
                <i class="pi pi-window-minimize" pTooltip="Minimize" (click)="onMaxWindowClick('')"></i>
              }
            </div>
            <div class="task-content" style="overflow-x: hidden">
              <div class="row m-0">
                @if (!viewFormDisabled) {
                  <div class="editor" style="width: 100%; padding: 0; margin: 0; margin-left: 0px">
                    <p-editor
                      formControlName="description"
                      name="description1"
                     
                      [style]="{ height: '400px', 'font-size': '18px' }"
                      (onTextChange)="onChangeDescription($event)"
                      styleClass="editorCreateTaskView"></p-editor>
                    <span class="maximize1" (click)="editmaximizeDescription()" style="cursor: pointer">
                      <i class="pi pi-window-maximize mr-2"></i>
                    </span>
                  </div>
                }

                @if (viewFormDisabled) {
                  <div class="editor" id="editorNew">
                    <div [innerHTML]="inputText" type="text" id="usrTextarea"></div>
                    <span class="maximize2" (click)="viewmaximizeDescription()" style="cursor: pointer">
                      <i class="pi pi-window-maximize mr-2"></i>
                    </span>
                  </div>
                }
              </div>
              <div class="row m-0">
                <div class="attachment-container col-header">
                  <!-- Attachments Count -->
                  <div class="attachmentDiv">
                    <span class="attachment-count">Attachments ({{ taskDataForEdit?.attachments?.length || 0 + files.length }})</span>
                    <label class="fileSizeLabel mb-0 ml-1 fileSizeMsgMulti" style="width: 200px">
                      <span class="text-danger">*</span>
                      Max file size: 30 MB per file.
                    </label>
                  </div>
                  <!-- Attach File Button -->
                  <input
                    type="button"
                    class="btn btn-sm attachfilebtn"
                    name="attachfile"
                    id="attachfile"
                    [disabled]="viewFormDisabled"
                    (click)="uploaders.click()"
                    value="{{ 'Attach File' | translate }}" />

                  <!-- Hidden File Input -->
                  <input
                    hidden
                    type="file"
                    [disabled]="viewFormDisabled"
                    (click)="uploaders.value = null"
                    (change)="onFileChange2($event)"
                    class="file"
                    id="addattachfile"
                    #uploaders
                    multiple />
                </div>
                <!-- Working Div -->

                <p-scrollPanel styleClass="mystyleCreate mystyleCreate-edit">
                  @for (
  files of (viewFormDisabled ? files.slice(0, 6) : files);
  track files;
  let index = $index
) {
                  <!-- @for (files of files; track files; let index = $index) { -->
                    <div [ngClass]="{ 'margin-class': isEditButtonClick == true }" *ngIf="!viewFormDisabled" style="margin-top: 0px; cursor: pointer;overflow-y: auto !important;" class="editAttachmentDiv">
                      <span class="widthFixed" style="display: inline-block" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "image/jpeg") {
                          <img
                            class="attachedImg"
                            (click)="openImage(index)"
                            tooltipPosition="left"
                            title="View Attachment"
                            title="{{ files.fileName }}"
                            style="width: 29px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/img.png" />
                        }
                      </span>
                      <span class="widthFixed" style="display: inline-block" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "jpeg") {
                          <img
                            class="attachedImg"
                            (click)="openImage(index)"
                            tooltipPosition="left"
                            title="{{ files.fileName }}"
                            style="width: 29px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/img.png" />
                        }
                      </span>
                         <span class="widthFixed" style="display: inline-block" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "jpg") {
                          <img
                            class="attachedImg"
                            (click)="openImage(index)"
                            tooltipPosition="left"
                            title="{{ files.fileName }}"
                            style="width: 29px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/img.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}" style="display: inline-block">
                        @if (files !== null && files["contentType"] == "png") {
                          <img
                            class="attachedImg"
                            (click)="openImage(index)"
                            tooltipPosition="left"
                            title="{{ files.fileName }}"
                            style="width: 29px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/img.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "image/png") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            style="width: 29px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/img.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/octet-stream") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}
                                                    "
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/docs.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/vnd.ms-excel") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/xl.png" />
                        }
                      </span>
                      <span title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            (click)="openImage(index)"
                            title="{{ files.fileName }}"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/xl.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/vnd.ms-excel.sheet.binary.macroenabled.12") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/xl.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/xl.png" />
                        }
                      </span>
                      <span>
                        @if (files !== null && files["contentType"] == "xlsx") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            pTooltip="{{ files.name }}"
                            style="width: 28px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/xl.png" />
                        }
                      </span>
                      <span title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "pdf") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            (click)="openImage(index)"
                            title="{{ files.fileName }}"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/pdf.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/pdf") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/pdf.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/docx") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/word.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "docx") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/word.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "csv") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="csv"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/csv.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "text/csv") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="csv"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/csv.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/ppt.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "pptx") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/ppt.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/word.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "video/quicktime") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 29px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/multimedia.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "video/mp4") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 29px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/multimedia.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["type"] == "video/quicktime") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 29px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/multimedia.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["type"] == "video/mp4") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 29px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/multimedia.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "text/plain") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/text.png" />
                        }
                      </span>
                      <span class="widthFixed" style="display: inline-block" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "txt") {
                          <img
                            class="attachedImg"
                            tooltipPosition="left"
                            title="View Attachment"
                            title="{{ files.fileName }}"
                            style="width: 29px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/text.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "zip") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="zip file"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/defaultFile.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/x-zip-compressed") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="zip file"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/defaultFile.png" />
                        }
                      </span>
                      @if (!viewFormDisabled) {
                        <img
                          (click)="removeSelectedFileEdit(index)"
                          src="../../../../assets/img/close.png"
                          alt="image"
                          style="width: 15px; display: inline-block; margin-left: -13px; cursor: pointer; margin-bottom: 21px" />
                      }
                    </div>


                     <div [ngClass]="{ 'margin-class': isEditButtonClick == true }" *ngIf="viewFormDisabled" style="margin-top: 0px; cursor: pointer;overflow-y: auto !important;" class="editAttachmentDiv">
                      <span class="widthFixed" style="display: inline-block" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "image/jpeg") {
                          <img
                            class="attachedImg"
                            (click)="openImage(index)"
                            tooltipPosition="left"
                            title="View Attachment"
                            title="{{ files.fileName }}"
                            style="width: 32px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/img.png" />
                        }
                      </span>
                      <span class="widthFixed" style="display: inline-block" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "jpeg") {
                          <img
                            class="attachedImg"
                            (click)="openImage(index)"
                            tooltipPosition="left"
                            title="{{ files.fileName }}"
                            style="width: 32px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/img.png" />
                        }
                      </span>
                         <span class="widthFixed" style="display: inline-block" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "jpg") {
                          <img
                            class="attachedImg"
                            (click)="openImage(index)"
                            tooltipPosition="left"
                            title="{{ files.fileName }}"
                            style="width: 32px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/img.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}" style="display: inline-block">
                        @if (files !== null && files["contentType"] == "png") {
                          <img
                            class="attachedImg"
                            (click)="openImage(index)"
                            tooltipPosition="left"
                            title="{{ files.fileName }}"
                            style="width: 32px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/img.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "image/png") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            style="width: 32px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/img.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/octet-stream") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}
                                                    "
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/docs.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/vnd.ms-excel") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/xl.png" />
                        }
                      </span>
                      <span title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            (click)="openImage(index)"
                            title="{{ files.fileName }}"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/xl.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/vnd.ms-excel.sheet.binary.macroenabled.12") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/xl.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/xl.png" />
                        }
                      </span>
                      <span>
                        @if (files !== null && files["contentType"] == "xlsx") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            pTooltip="{{ files.name }}"
                            style="width: 28px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/xl.png" />
                        }
                      </span>
                      <span title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "pdf") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            (click)="openImage(index)"
                            title="{{ files.fileName }}"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/pdf.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/pdf") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/pdf.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/docx") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/word.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "docx") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/word.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "csv") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="csv"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/csv.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "text/csv") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="csv"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/csv.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/ppt.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "pptx") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/ppt.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/word.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "video/quicktime") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 32px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/multimedia.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "video/mp4") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 32px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/multimedia.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["type"] == "video/quicktime") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 32px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/multimedia.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["type"] == "video/mp4") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 32px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/multimedia.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "text/plain") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="image"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/text.png" />
                        }
                      </span>
                      <span class="widthFixed" style="display: inline-block" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "txt") {
                          <img
                            class="attachedImg"
                            tooltipPosition="left"
                            title="View Attachment"
                            title="{{ files.fileName }}"
                            style="width: 32px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            alt="image"
                            src="../../assets/img/text.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "zip") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="zip file"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/defaultFile.png" />
                        }
                      </span>
                      <span class="widthFixed" title="{{ files.fileName }}">
                        @if (files !== null && files["contentType"] == "application/x-zip-compressed") {
                          <img
                            class="attachedImg"
                            tooltipPosition="bottom"
                            title="{{ files.fileName }}"
                            (click)="openImage(index)"
                            alt="zip file"
                            style="width: 33px; margin-right: 15px"
                            tooltipStyleClass="custom-tooltip"
                            src="../../assets/img/defaultFile.png" />
                        }
                      </span>

                    </div>
                     
               
                  }
               @if (files && files.length > 6) {
  <div style="display: flex; justify-content: flex-end;">
    <div
      *ngIf="viewFormDisabled"
      (click)="openImageshowmore()"
      style="position: relative; width: 32px; cursor: pointer;"
    >
      <img
        src="../../assets/img/img.png"
        alt="Show More"
        style="width: 100%; height: 100%; object-fit: cover; border-radius: 5px;"
      />

      <div style="
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.45);
        color: white;
        font-weight: bold;
        font-size: 14px;
        border-radius: 5px;
      ">
        +{{ files.length - 6 }}
      </div>
    </div>
  </div>
}
                </p-scrollPanel>
              </div>
            </div>
          </div>
        </div>
        <!-- Comments Section -->
        <div
          class="view-cols comments-col"
          [ngClass]="{
            'col-6': expandedCol == 'Comments',
            'col-3': expandedCol == '',
            'col-2': expandedCol != '' && expandedCol != 'Comments',
          }">
          <div class="col-card">
            <div class="col-header">
              <span class="pl-1">Comments</span>
              @if (expandedCol != "Comments") {
                <i class="pi pi-window-maximize" pTooltip="Maximize" (click)="onMaxWindowClick('Comments')"></i>
              }
              @if (expandedCol == "Comments") {
                <i class="pi pi-window-minimize" pTooltip="Minimize" (click)="onMaxWindowClick('')"></i>
              }
            </div>
            <div class="task-content">
              <div class="search-wrapper mt-0">
                <input
                  class="input-box"
                  type="text"
                  (input)="searchComment(searchCommentText)"
                  id="commentsearch"
                  name="commentsearch"
                  [(ngModel)]="searchCommentText"
                  placeholder="Search"
                  [ngModelOptions]="{ standalone: true }" />
                <span class="search-icon"><i class="search-icon-img pi pi-search"></i></span>
              </div>
              <div class="comment-container mt-2">
                @for (comment of taskDataForEdit?.comments; track comment) {
                  <div class="commentsDiv">
                    <div class="comment-header">
                      <span class="name">{{ comment.commentedBy }}</span>
                      <span class="time">{{ date(comment.commentedDate) | date: "MM/dd/yyyy" }}-{{ time(comment.commentedDate) }}</span>
                    </div>
                    <div class="comment" (click)="onImageClick($event, comment)" [innerHtml]="comment.comment"></div>
                  </div>
                }
              </div>
              <div class="row m-0">
                <p-editor
                  [(ngModel)]="addedComment"
                  class="editorTaskCommnet"
                  [ngModelOptions]="{ standalone: true }"
                  [style]="{ height: '157px', 'padding-bottom': '5px', width: '100%' ,'font-size': '18px' }"
                  (onTextChange)="onChangeComment($event)"
                  styleClass="editorCreateTaskCommnet"></p-editor>
              </div>
              @if (isValidComment == true || isValidComment1 == true) {
                <div class="invalid-feedback" style="font-size: 11px !important">{{ "validComment" | translate }}</div>
              }
              @if (isStatusSelected) {
                <div class="invalid-feedback" style="font-size: 11px !important">
                  {{ "commentIsMandatoryForSelectedStatus" | translate }} {{ showSelectedStatus }} {{ "status" | translate }}.
                </div>
              }
              <div class="row justify-content-end mb-1 mr-2">
                <input
                  type="button"
                  class="btn btn-default submitBtnComment createBtnCommnet"
                  value="{{ 'addCommentBTN' | translate }}"
                  (click)="saveComment()"
                  [disabled]="!addedComment || isValidComment == true || isValidComment1 == true" />
              </div>
            </div>
          </div>
        </div>

        <!-- History Section -->
        <div
          class="view-cols history-col"
          [ngClass]="{
            'col-6': expandedCol == 'History',
            'col-3': expandedCol == '',
            'col-2': expandedCol != '' && expandedCol != 'History',
          }">
          <div class="col-card Last">
            <div class="col-header">
              <img class="header-icon" src="assets/img/history.svg" alt="" />
              <span class="pl-1">History</span>
              @if (expandedCol != "History") {
                <i class="pi pi-window-maximize" pTooltip="Maximize" (click)="onMaxWindowClick('History')"></i>
              }
              @if (expandedCol == "History") {
                <i class="pi pi-window-minimize" pTooltip="Minimize" (click)="onMaxWindowClick('')"></i>
              }
            </div>
            <div class="task-content">
              <div class="search-wrapper mt-0">
                <input
                  class="input-box"
                  type="text"
                  name="historysearch"
                  id="historysearch"
                  [(ngModel)]="historySearchText"
                  [ngModelOptions]="{ standalone: true }"
                  (input)="historyTab1.filterGlobal($event.target.value, 'contains')" />
                <span class="search-icon">
                  <i class="search-icon-img pi pi-search"></i>
                </span>
              </div>
              <div class="history-table-container">
                <p-table
                  class="histortTable"
                  #historyTab1
                  [columns]="historyCols"
                  [value]="HistoryData"
                  [paginator]="showHistoryPagination"
                  [rows]="16"
                  [globalFilterFields]="['createdDate', 'createdBy', '']">
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th class="changeDate">{{ "changeDate" | translate }}</th>
                      <th class="changeBy">{{ "changeBy" | translate }}</th>
                      <th class="statuscss">{{ "comments" | translate }}</th>
                      <th class="statuscss">{{ "details" | translate }}</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-historyData let-columns="columns" let-rowIndex="rowIndex">
                    <tr>
                      <td
                        class="changeDate"
                        tooltipPosition="top"
                        pTooltip="{{ historyData.createdDate | date: 'MM/dd/yyyy' }}"
                        tooltipStyleClass="custom-tooltip">
                        {{ historyData.createdDate | date: "MM/dd/yyyy" }}
                      </td>
                      <td class="changeBy" tooltipPosition="top" pTooltip="{{ historyData.createdBy }}" tooltipStyleClass="custom-tooltip">
                        {{ historyData.createdBy }}
                      </td>
                      <td class="statuscss" tooltipPosition="top" pTooltip="{{ historyData.actionTaken }}" tooltipStyleClass="custom-tooltip">
                        {{ historyData.actionTaken }}
                      </td>
                      <td class="statuscss" tooltipPosition="top" pTooltip="{{ historyData.newValue }}" tooltipStyleClass="custom-tooltip">
                        {{ historyData.newValue }}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- Button Row-->
    @if (onEditClickCheck === false) {
      <div class="d-flex justify-content-end flex-wrap button-container w-100 mt-2" style="gap: 15px; padding: 2px">
        <button type="button" class="btn btn-default submitBtnsNew" (click)="CancelViewForm()" style="line-height: 1">
          {{ "cancelBTN" | translate }}
        </button>
        @if (lang != "en") {
          <button type="button" class="btn btn-default submitBtnsNew copybtn" (click)="openCopyTask()" style="padding: 5px">
            <i class="pi pi-copy copyico"></i>
            <div class="copytxt">{{ "copyBTN" | translate }}</div>
          </button>
        }
        @if (lang == "en") {
          <button type="button" class="btn btn-default submitBtnsNew copybtn" (click)="openCopyTask()" style="padding: 5px">
            <i class="pi pi-copy copyico"></i>
            <div class="copytxt">{{ "copyBTN" | translate }}</div>
          </button>
        }
        <button type="button" class="btn btn-default submitBtnView" (click)="editFormOpen()" style="height: auto !important; margin-right: 15px">
          {{ "editBTN" | translate }}
        </button>
      </div>
    }

    @if (onEditClickCheck === true) {
      <div class="d-flex justify-content-end flex-wrap mt-2 updatebtnscss w-100" style="gap: 0px; padding: 2px">
        @if (lang != "en") {
          <button type="button" class="btn btn-default submitBtnsNew" (click)="CancelViewForm()">
            {{ "cancelBTN" | translate }}
          </button>
        }
        @if (lang == "en") {
          <button type="button" class="btn btn-default submitBtnsNew" (click)="CancelViewForm()">
            {{ "cancelBTN" | translate }}
          </button>
        }
        @if (lang != "en") {
          <button type="button" class="btn btn-default submitBtnsNew copybtn" (click)="openCopyTask()">
            <i class="pi pi-copy copyico"></i>
            <div class="copytxt">{{ "copyBTN" | translate }}</div>
          </button>
        }
        @if (lang == "en") {
          <button type="button" class="btn btn-default submitBtnsNew copybtn" (click)="openCopyTask()">
            <i class="pi pi-copy copyico"></i>
            <div class="copytxt">{{ "copyBTN" | translate }}</div>
          </button>
        }
        @if (lang == "fr") {
          <input
            type="submit"
            class="btn btn-default submitBtnDash updateBtnUpdateTask"
            value="{{ 'updateBTN' | translate }}"
            [disabled]="
              !viewForm.valid || isStatusSelected == true || isValidDesc == true || isValidDesc1 == true || !isValidatedManField || !isValidatedNonManField
            "
            style="margin-right: 15px; cursor: pointer; bottom: 5px; height: auto"
            (click)="UpdateTask(viewForm.value)" />
        }
        @if (lang != "fr") {
          <input
            type="submit"
            class="btn btn-default submitBtnDash updateBtnUpdateTask"
            value="{{ 'updateBTN' | translate }}"
            [disabled]="
              !viewForm.valid || isStatusSelected == true || isValidDesc == true || isValidDesc1 == true || !isValidatedManField || !isValidatedNonManField
            "
            style="margin-right: 15px; cursor: pointer; bottom: 5px; height: auto"
            (click)="UpdateTask(viewForm.value)" />
        }
      </div>
    }
  </div>
</p-dialog>

<p-dialog
  class="showDocument"
  header="Preview"
  [(visible)]="showDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="true"
  [closable]="false"
  [baseZIndex]="10000"
  (onShow)="onDialogShow()">
  <div class="row m-0 justify-content-end"><i class="pi pi-times close-icon" (click)="showDialog = false"></i></div>
  <div class="carousel-container mt-2">
    @if (showCarousel) {
    <carousel [interval]="0" [(activeSlide)]="selectedIndex" [showControls]="true">
      @for (item of imageAttachment; track item; let i = $index) {
        <slide>
          <div class="text-center py-5">
            @if (item.contentType === "application/pdf") {
              <div>
                <!-- <pdf-viewer [src]="item.thumbnailImageSrc" [render-text]="true"
                                                  [original-size]="true"></pdf-viewer> -->
                <div class="label-center">
                  <div class="mt-2 label-file">Click on filename to download*</div>
                  <label class="label-document mt-1" (click)="openDocumentInNewTab(item.thumbnailImageSrc, item.title)">
                    {{ item.title }}
                  </label>
                  <button type="button" class="btn btn-primary dialogCancelBtn" (click)="showDialog = false">
                    {{ "cancelBTN" | translate }}
                  </button>
                </div>
              </div>
            }
            @if (item.contentType === "image/png" || item.contentType === "image/jpeg") {
              <div>
                <img [src]="item.thumbnailImageSrc" alt="{{ item.title }}" class="image-preview" />
                <div class="label-center">
                  <div class="mt-2 label-file">Click on filename to download*</div>
                  <label (click)="openDocumentInNewTab(item.thumbnailImageSrc, item.title)" class="label-document mt-1">
                    {{ item.title }}
                  </label>
                  <button type="button" class="btn btn-primary dialogCancelBtn" (click)="showDialog = false">
                    {{ "cancelBTN" | translate }}
                  </button>
                </div>
              </div>
            }
            @if (item.contentType === "video/mp4") {
              <div style="text-align: center">
                <video controls style="width: 80%; height: 30vw">
                  <source [src]="item.thumbnailImageSrc" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <div class="label-center">
                  <div class="mt-2 label-file">Click on filename to download*</div>
                  <label class="label-document mt-1" (click)="openDocumentInNewTab(item.thumbnailImageSrc, item.title)">
                    {{ item.title }}
                  </label>
                  <button type="button" class="btn btn-primary dialogCancelBtn" (click)="showDialog = false">
                    {{ "cancelBTN" | translate }}
                  </button>
                </div>
              </div>
            }
            @if (
              item.contentType !== "application/pdf" &&
              item.contentType !== "image/png" &&
              item.contentType !== "image/jpeg" &&
              item.contentType !== "video/mp4"
            ) {
              <div class="unsupported-file">
                <div class="label-center">
                  <div class="mt-2 label-file" style="color: #de3730">Click below to download*</div>
                  <label class="label-document mt-1" (click)="openDocumentInNewTab(item.thumbnailImageSrc, item.title)">
                    {{ item.title }} {{ item.contentType }}
                  </label>
                  <button type="button" class="btn btn-primary dialogCancelBtn" (click)="showDialog = false">
                    {{ "cancelBTN" | translate }}
                  </button>
                </div>
              </div>
            }
          </div>
        </slide>
      }
      <!-- Previous Button -->
      <i
        class="fas fa-chevron-left carousel-control-prev-icon"
        style="cursor: pointer !important; position: absolute; top: 50%; left: 10px; transform: translateY(-50%); font-size: 24px"
        (click)="selectedIndex = (selectedIndex - 1 + imageAttachment.length) % imageAttachment.length"></i>

      <!-- Next Button -->
      <i
        class="fas fa-chevron-right carousel-control-next-icon"
        style="cursor: pointer !important; position: absolute; top: 50%; right: 10px; transform: translateY(-50%); font-size: 24px"
        (click)="selectedIndex = (selectedIndex + 1) % imageAttachment.length"></i>
    </carousel>
  }
    <!-- <p-carousel [value]="imageAttachment" [numVisible]="1" [numScroll]="1" [circular]="true" [autoplayInterval]="0"
                                      [(page)]="selectedIndex">
                                      <ng-template let-item pTemplate="item">
                                        <div class="slide-content">
                                          <div *ngIf="item.contentType === 'application/pdf'">
                                            <pdf-viewer [src]="item.thumbnailImageSrc" [render-text]="true"
                                            [original-size]="true"></pdf-viewer>
                                            <div class="label-center">
                                              <div class="mt-2 label-file">Click on filename to download*</div>
                                              <label class="label-document mt-1"
                                                (click)="openDocumentInNewTab(item.thumbnailImageSrc, item.title)">
                                                {{item.title}}
                                              </label>
                                              <button type="button" class="btn btn-primary dialogCancelBtn" (click)="showDialog = false">
                                                {{ "cancelBTN" | translate }}
                                              </button>
                                            </div>
                                          </div>

                                          <div *ngIf="item.contentType === 'image/png' || item.contentType === 'image/jpeg'">
                                            <img [src]="item.thumbnailImageSrc" alt="{{item.title}}" class="image-preview" />
                                            <div class="label-center">
                                              <div class="mt-2 label-file">Click on filename to download*</div>
                                              <label (click)="openDocumentInNewTab(item.thumbnailImageSrc, item.title)"
                                                class="label-document mt-1">
                                                {{item.title}}
                                              </label>
                                              <button type="button" class="btn btn-primary dialogCancelBtn" (click)="showDialog = false">
                                                {{ "cancelBTN" | translate }}
                                              </button>
                                            </div>
                                          </div>

                                          <div *ngIf="item.contentType === 'video/mp4'" style="text-align: center;">
                                            <video controls style="width: 80%; height: 30vw;">
                                              <source [src]="item.thumbnailImageSrc" type="video/mp4">
                                              Your browser does not support the video tag.
                                            </video>
                                            <div class="label-center">
                                              <div class="mt-2 label-file">Click on filename to download*</div>
                                              <label class="label-document mt-1"
                                                (click)="openDocumentInNewTab(item.thumbnailImageSrc, item.title)">
                                                {{item.title}}
                                              </label>
                                              <button type="button" class="btn btn-primary dialogCancelBtn" (click)="showDialog = false">
                                                {{ "cancelBTN" | translate }}
                                              </button>
                                            </div>

                                          </div>

                    <div *ngIf="item.contentType !== 'application/pdf' && item.contentType !== 'image/png' && 
                                 item.contentType !== 'image/jpeg' && item.contentType !== 'video/mp4'"
                                            class="unsupported-file">
                                            <div class="label-center">
                            <div class="mt-2 label-file" style="
                            color: #de3730;
                        ">Click below to download*</div>
                                              <label class="label-document mt-1"
                                                (click)="openDocumentInNewTab(item.thumbnailImageSrc, item.title)">
                                                {{item.title}}
                                              </label>
                                              <button type="button" class="btn btn-primary dialogCancelBtn" (click)="showDialog = false">
                                                {{ "cancelBTN" | translate }}
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </ng-template>
                                    </p-carousel> -->
  </div>
</p-dialog>

<p-dialog
  header="{{ 'taskRecurrence' | translate }}"
  (onHide)="canceltaskRecurrence()"
  [(visible)]="displaytaskrecurrence"
  [modal]="true"
  styleClass="overlayDialogrecurrence"
  [style]="{ width: '545px', height: '388px' }"
  [draggable]="false"
  [baseZIndex]="999999">
  <form #recForm="ngForm">
    <p class="titleRe">{{ "rangeOfRecurrence" | translate }}</p>
    <div class="row m-0 mt-1">
      <div class="form-inline col-4 p-0" style="margin-top: -51px">
        <label class="subtitle" style="margin-left: 13px !important" for="start">{{ "start" | translate }}</label>
        <p-datepicker
          class="recCalendar ml-2"
          id="start"
          name="start"
          [(ngModel)]="recStartDate"
          [required]="true"
          [minDate]="todayDate"
          appendTo="body"
          panelStyleClass="rec-cal"></p-datepicker>
      </div>
      <div class="col-8">
        <div>
          <div class="task-ref-grid">
            <div class="d-flex align-items-center recRadio">
              <p-radiobutton
                [(ngModel)]="endRadio"
                [ngModelOptions]="{ standalone: true }"
                name="group"
                value="endby"
                inputId="opt21"
                (onClick)="changeRangeRecRadio('endby')" />
              <label for="opt21" class="text-nowrap">{{ "endBy" | translate }}</label>
            </div>
            <p-datepicker
              id="end"
              name="end"
              class="recCalendar recCalendar1"
              [(ngModel)]="recEndDate"
              [required]="endRadio == 'endby'"
              [disabled]="endRadio != 'endby'"
              [minDate]="recStartDate"
              appendTo="body"
              panelStyleClass="rec-cal"></p-datepicker>
          </div>
          <div class="task-ref-grid">
            <div class="d-flex align-items-center recRadio">
              <p-radiobutton
                [(ngModel)]="endRadio"
                [ngModelOptions]="{ standalone: true }"
                name="group"
                value="endafter"
                inputId="opt22"
                (onClick)="changeRangeRecRadio('endafter')" />
              <label for="opt22" class="text-nowrap">{{ "endAfter" | translate }}</label>
            </div>
            <div class="d-flex align-items-center">
              @if (lang != "es") {
                <input
                  class="inputNumber"
                  id="recno"
                  name="recno"
                  type="number"
                  min="1"
                  [(ngModel)]="noOfRec"
                  [disabled]="endRadio != 'endafter'"
                  [required]="endRadio == 'endafter'" />
              }
              @if (lang == "es") {
                <input
                  class="inputNumber"
                  id="recno"
                  name="recno"
                  type="number"
                  min="1"
                  [(ngModel)]="noOfRec"
                  [disabled]="endRadio != 'endafter'"
                  [required]="endRadio == 'endafter'"
                  style="margin-left: 28px !important" />
              }
              <label class="textLabel ml-2 mb-0">{{ "occurrences" | translate }}</label>
            </div>
          </div>
          <div class="d-flex align-items-center recRadio">
            <p-radiobutton [(ngModel)]="endRadio" name="group" value="noenddate" inputId="opt23" (onClick)="changeRangeRecRadio('noenddate')" />
            <label for="opt23" class="text-nowrap">{{ "noEndDate" | translate }}</label>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <p class="titleRe">{{ "recurrencePattern" | translate }}</p>
    <div class="row m-0 mt-2">
      <div class="col-3 pr-0">
        <div class="d-flex align-items-center recRadio">
          <p-radiobutton [(ngModel)]="patternRadio" name="group1" value="Daily" inputId="opt1" (onClick)="changePatternRadio('Daily')" />
          <label for="opt1" class="ml-2">{{ "daily" | translate }}</label>
        </div>
        <div class="d-flex align-items-center recRadio">
          <p-radiobutton [(ngModel)]="patternRadio" name="group1" value="Weekly" inputId="opt2" (onClick)="changePatternRadio('Weekly')" />
          <label for="opt2" class="ml-2">{{ "weekly" | translate }}</label>
        </div>
        <div class="d-flex align-items-center recRadio">
          <p-radiobutton [(ngModel)]="patternRadio" name="group1" value="Monthly" inputId="opt3" (onClick)="changePatternRadio('Monthly')" />
          <label for="opt3" class="ml-2">{{ "monthly" | translate }}</label>
        </div>
        <div class="d-flex align-items-center recRadio">
          <p-radiobutton [(ngModel)]="patternRadio" name="group1" value="Yearly" inputId="opt4" (onClick)="changePatternRadio('Yearly')" />
          <label for="opt4" class="ml-2">{{ "yearly" | translate }}</label>
        </div>
      </div>
      <div class="col-9 pl-0">
        <div class="patternDiv">
          <!-- Daily -->
          @if (patternRadio == "Daily") {
            <div class="ml-3 mt-2">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center recRadio">
                  <p-radiobutton [(ngModel)]="dailyRadio" name="group2" value="everyday" inputId="opt11" (onClick)="changeDailyRadios('everyday')" />
                  <label for="opt11" class="ml-2">{{ "every" | translate }}</label>
                </div>
                <input
                  class="inputNumber ml-2 mb-2"
                  id="dailyno"
                  name="dailyno"
                  type="number"
                  min="1"
                  [(ngModel)]="dailyNumber"
                  [disabled]="dailyRadio == 'everyweekday' || dailyRadio == null"
                  [required]="dailyRadio == 'everyday'" />
                <label class="ml-2 textLabel">{{ "days" | translate }}</label>
              </div>
              <div class="d-flex align-items-center recRadio">
                <p-radiobutton [(ngModel)]="dailyRadio" name="group2" value="everyweekday" inputId="opt12" (onClick)="changeDailyRadios('everyweekday')" />
                <label for="opt12" class="ml-2">{{ "everyWeekday" | translate }}</label>
              </div>
            </div>
          }
          <!-- weekly -->
          @if (patternRadio == "Weekly") {
            <div class="ml-1 mt-2">
              <div class="row m-0">
                <label class="textLabel ml-2">{{ "recur" | translate }}</label>
                <input class="inputNumber ml-1" id="weekNo" name="weekNo" type="number" min="1" [(ngModel)]="weekno" required />
                <label class="textLabel ml-1">{{ "week" | translate }} {{ "on" | translate }}:</label>
                <!-- week(s) on -->
              </div>
              @if (lang != "fr") {
                <div class="row" style="margin-top: -24px; margin-left: 200px">
                  <div class="col p-0">
                    <div>
                      <p-checkbox class="recCheckbox" name="group3" value="Monday" [(ngModel)]="selectedWeekday" inputId="mo"></p-checkbox>
                      <label for="mo" class="ml-2 mb-0">{{ "monday" | translate }}</label>
                    </div>
                    <div>
                      <p-checkbox class="recCheckbox" name="group3" value="Tuesday" [(ngModel)]="selectedWeekday" inputId="tu"></p-checkbox>
                      <label for="tu" class="ml-2 mb-0">{{ "tuesday" | translate }}</label>
                    </div>
                    <div>
                      <p-checkbox class="recCheckbox" name="group3" value="Wednesday" [(ngModel)]="selectedWeekday" inputId="wed"></p-checkbox>
                      <label for="wed" class="ml-2 mb-0">{{ "wednesday" | translate }}</label>
                    </div>
                    <div>
                      <p-checkbox class="recCheckbox" name="group3" value="Thursday" [(ngModel)]="selectedWeekday" inputId="thu"></p-checkbox>
                      <label for="thu" class="ml-2 mb-0">{{ "thursday" | translate }}</label>
                    </div>
                  </div>
                  <div class="col p-0">
                    <div>
                      <p-checkbox class="recCheckbox" name="group3" value="Friday" [(ngModel)]="selectedWeekday" inputId="fri"></p-checkbox>
                      <label for="fri" class="ml-2 mb-0">{{ "friday" | translate }}</label>
                    </div>
                    <div>
                      <p-checkbox class="recCheckbox" name="group3" value="Saturday" [(ngModel)]="selectedWeekday" inputId="sat"></p-checkbox>
                      <label for="sat" class="ml-2 mb-0">{{ "saturday" | translate }}</label>
                    </div>
                    <div>
                      <p-checkbox class="recCheckbox" name="group3" value="Sunday" [(ngModel)]="selectedWeekday" inputId="sun"></p-checkbox>
                      <label for="sun" class="ml-2 mb-0">{{ "sunday" | translate }}</label>
                    </div>
                  </div>
                </div>
              }
              @if (lang == "fr") {
                <div class="row" style="margin-top: -24px; margin-left: 233px">
                  <div class="col p-0">
                    <div>
                      <p-checkbox class="recCheckbox" name="group3" value="Monday" [(ngModel)]="selectedWeekday" inputId="mo"></p-checkbox>
                      <label for="mo" class="ml-2">{{ "monday" | translate }}</label>
                    </div>
                    <div>
                      <p-checkbox class="recCheckbox" name="group3" value="Tuesday" [(ngModel)]="selectedWeekday" inputId="tu"></p-checkbox>
                      <label for="tu" class="ml-2">{{ "tuesday" | translate }}</label>
                    </div>
                    <div>
                      <p-checkbox class="recCheckbox" name="group3" value="Wednesday" [(ngModel)]="selectedWeekday" inputId="wed"></p-checkbox>
                      <label for="wed" class="ml-2">{{ "wednesday" | translate }}</label>
                    </div>
                    <div>
                      <p-checkbox class="recCheckbox" name="group3" value="Thursday" [(ngModel)]="selectedWeekday" inputId="thu"></p-checkbox>
                      <label for="thu" class="ml-2">{{ "thursday" | translate }}</label>
                    </div>
                  </div>
                  <div class="col p-0">
                    <div>
                      <p-checkbox class="recCheckbox" name="group3" value="Friday" [(ngModel)]="selectedWeekday" inputId="fri"></p-checkbox>
                      <label for="fri" class="ml-2">{{ "friday" | translate }}</label>
                    </div>
                    <div>
                      <p-checkbox class="recCheckbox" name="group3" value="Saturday" [(ngModel)]="selectedWeekday" inputId="sat"></p-checkbox>
                      <label for="sat" class="ml-2">{{ "saturday" | translate }}</label>
                    </div>
                    <div>
                      <p-checkbox class="recCheckbox" name="group3" value="Sunday" [(ngModel)]="selectedWeekday" inputId="sun"></p-checkbox>
                      <label for="sun" class="ml-2">{{ "sunday" | translate }}</label>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          <!-- Monthly -->
          @if (patternRadio == "Monthly") {
            <div class="ml-3 mt-2">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center recRadio">
                  <p-radiobutton
                    [(ngModel)]="monthlyRadio"
                    name="group4"
                    value="dayofeverymonth"
                    inputId="opt31"
                    (onClick)="onChangeMonthlyRadio('dayofeverymonth')" />
                  <label for="opt31" class="ml-2">{{ "day" | translate }}</label>
                </div>
                <input
                  class="inputNumber ml-1 mb-2"
                  id="monthno"
                  name="monthno"
                  type="number"
                  min="1"
                  [(ngModel)]="monthNumber"
                  [disabled]="monthlyRadio == 'thofeverymonth' || monthlyRadio == null"
                  [required]="monthlyRadio != 'thofeverymonth'" />
                <label class="textLabel ml-1">{{ "ofEvery" | translate }}</label>
                <input
                  class="inputNumber ml-1 mb-2"
                  id="monthno1"
                  name="monthno1"
                  type="number"
                  min="1"
                  [(ngModel)]="monthNumber1"
                  [disabled]="monthlyRadio == 'thofeverymonth' || monthlyRadio == null"
                  [required]="monthlyRadio != 'thofeverymonth'" />
                <label class="textLabel ml-1">{{ "months" | translate }}</label>
              </div>
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center recRadio">
                  <p-radiobutton
                    [(ngModel)]="monthlyRadio"
                    name="group4"
                    value="thofeverymonth"
                    inputId="opt32"
                    (onClick)="onChangeMonthlyRadio('thofeverymonth')" />
                  <label for="opt32" class="ml-2">{{ "the" | translate }}</label>
                </div>
                <p-select
                  class="ml-1 monthdropdown"
                  #monthDD
                  id="monthdropdown"
                  name="monthdropdown"
                  placeholder="{{ 'select' | translate }}"
                  [options]="monthFirstddData"
                  [(ngModel)]="monthdd"
                  optionLabel="name"
                  [disabled]="monthlyRadio != 'thofeverymonth' || monthlyRadio == null"
                  [required]="monthlyRadio == 'thofeverymonth'"
                  appendTo="body"></p-select>
                <p-select
                  class="ml-1 monthdropdown"
                  #monthDD1
                  id="monthdropdown1"
                  name="monthdropdown1"
                  placeholder="{{ 'select' | translate }}"
                  [options]="monthSecondddData"
                  [(ngModel)]="monthdd1"
                  optionLabel="name"
                  [disabled]="monthlyRadio != 'thofeverymonth' || monthlyRadio == null"
                  [required]="monthlyRadio == 'thofeverymonth'"
                  appendTo="body"></p-select>
                <label class="textLabel ml-1">{{ "ofEvery" | translate }}</label>
                <input
                  class="inputNumber ml-1"
                  id="monthno2"
                  name="monthno2"
                  type="number"
                  min="1"
                  [(ngModel)]="monthNumber11"
                  [disabled]="monthlyRadio != 'thofeverymonth' || monthlyRadio == null"
                  [required]="monthlyRadio == 'thofeverymonth'" />
                <label class="textLabel ml-1">{{ "months" | translate }}</label>
                <!-- months(s) -->
              </div>
            </div>
          }
          <!-- Yearly -->
          @if (patternRadio == "Yearly") {
            <div class="mt-1">
              <div class="row ml-2 m-0">
                <label class="textLabel ml-2">{{ "recurEvery" | translate }}</label>
                <input class="inputNumber ml-1" id="weekNo" name="weekNo" type="number" min="1" [(ngModel)]="yearno" required />
                <label class="textLabel ml-1">{{ "years" | translate }}</label>
                <!-- years(s) -->
              </div>
              <div class="ml-3 d-flex align-items-center">
                <div class="d-flex align-items-center recRadio">
                  <p-radiobutton [(ngModel)]="yearlyRadio" name="group5" value="on" inputId="opt41" (onClick)="changeYearlyRadio('on')" />
                  <label for="opt41" class="ml-2">{{ "on" | translate }}</label>
                </div>
                <p-select
                  class="ml-1 monthdropdown"
                  #yearDD
                  id="yeardd"
                  name="yeardd"
                  placeholder="{{ 'select' | translate }}"
                  [options]="yearlyddData"
                  [(ngModel)]="yearDd1"
                  optionLabel="name"
                  [disabled]="yearlyRadio == 'onthe' || yearlyRadio == null"
                  [required]="yearlyRadio == 'on'"
                  appendTo="body"></p-select>
                <input
                  class="inputNumber ml-1"
                  id="yearno1"
                  name="yearno1"
                  type="number"
                  min="1"
                  [(ngModel)]="yearNumber1"
                  [disabled]="yearlyRadio == 'onthe' || yearlyRadio == null"
                  [required]="yearlyRadio != 'onthe'" />
              </div>
              <div class="ml-3 mt-1 d-flex align-items-center">
                <div class="d-flex align-items-center recRadio">
                  <p-radiobutton [(ngModel)]="yearlyRadio" name="group5" value="onthe" inputId="opt42" (onClick)="changeYearlyRadio('onthe')" />
                  <label for="opt42" class="ml-2">{{ "onThe" | translate }}</label>
                </div>
                <p-select
                  class="ml-1 monthdropdown"
                  #monthDD
                  id="yeardd1"
                  name="yeardd1"
                  placeholder="{{ 'select' | translate }}"
                  [options]="monthFirstddData"
                  [(ngModel)]="yearDd2"
                  optionLabel="name"
                  [disabled]="yearlyRadio == 'on' || yearlyRadio == null"
                  [required]="yearlyRadio == 'onthe'"
                  appendTo="body"></p-select>
                <p-select
                  class="ml-1 monthdropdown"
                  #monthDD1
                  id="yeardd2"
                  name="yeardd2"
                  placeholder="{{ 'select' | translate }}"
                  [options]="monthSecondddData"
                  [(ngModel)]="yearDd3"
                  optionLabel="name"
                  [disabled]="yearlyRadio == 'on' || yearlyRadio == null"
                  [required]="yearlyRadio == 'onthe'"
                  appendTo="body"></p-select>
                <label class="textLabel ml-1">{{ "of" | translate }}</label>
                <p-select
                  class="ml-1 monthdropdown"
                  #yearDD
                  id="yeardd3"
                  name="yeardd3"
                  placeholder="{{ 'select' | translate }}"
                  [options]="yearlyddData"
                  [(ngModel)]="yearDd4"
                  optionLabel="name"
                  [disabled]="yearlyRadio == 'on' || yearlyRadio == null"
                  [required]="yearlyRadio == 'onthe'"
                  appendTo="body"></p-select>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="row justify-content-end m-0 mt-3">
      <button class="btn btn-sm mr-2 recBtn" (click)="createRecurrence()" [disabled]="recForm.invalid">
        {{ "okBTN" | translate }}
      </button>
      <button class="btn btn-sm mr-2 recBtn" (click)="canceltaskRecurrence()">
        {{ "cancelSmallCaps" | translate }}
      </button>
      <button class="btn btn-sm mr-4 recBtn" (click)="removeRecurrence()" [disabled]="displayFeedback == true">
        {{ "removeRecurrence" | translate }}
      </button>
    </div>
  </form>
</p-dialog>

<p-dialog
  header="{{ 'addWatchlist' | translate }}"
  [(visible)]="displayWatchlist"
  [modal]="true"
  styleClass="overlayDialogWatchlist"
  [style]="{ width: '400px', height: '218px' }"
  [draggable]="false">
  <form [formGroup]="watchlistForm" (ngSubmit)="addWatchlist(watchlistForm.value)">
    <div style="margin-left: 0px; display: inline-block; margin-top: 20px">
      <div class="ui-g-12 ui-md-12" style="display: inline-block; margin-bottom: 20px">
        <p class="commonhead assignLabels widthTitle" style="display: inline-block">
          {{ "estimate" | translate }}
        </p>
        <div class="ui-inputgroup" style="display: inline-block">
          <input
            type="text"
            pInputText
            placeholder="{{ 'addWatchlistName' | translate }}"
            style="height: 28px; width: 206px"
            formControlName="watchlistName"
            id="watchListNameAdd" />
        </div>
      </div>
      <div style="margin-top: 25px; margin-left: 7px">
        <p class="commonhead assignLabels widthTitle" style="display: inline-block">
          {{ "default" | translate }}
        </p>
        <p-checkbox
          formControlName="default"
          name="privateTask"
          binary="true"
          class="watchCheckboc"
          class="watchlistClass"
          styleClass="privateSpanOccurenceb"></p-checkbox>
      </div>
    </div>
    <div style="margin-left: 172px">
      <button type="button" class="btn btn-default submitBtns" (click)="closeWatchlist()" style="position: absolute; right: 162px; bottom: 11px">
        {{ "cancelBTN" | translate }}
      </button>
      <input
        type="submit"
        class="btn btn-default submitBtnDash"
        id="btnCreateBtn"
        value="{{ 'createBTN' | translate }}"
        [disabled]="!watchlistForm.valid"
        style="margin-right: 15px; position: absolute; right: 48px; cursor: pointer; bottom: 11px" />
    </div>
  </form>
</p-dialog>

<p-dialog
  class="showDocumentPreview"
  header="Preview"
  [(visible)]="showCommentPreview"
  [style]="{ width: '80vw' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="true"
  [closable]="false"
  [baseZIndex]="10000">
    <div class="row m-0 justify-content-end"><i class="pi pi-times close-icon" (click)="showCommentPreview = false"></i></div>

  <!-- <div class="image-preview" [innerHTML]="selectedImage"></div> -->
  <div class="carousel-container">
    <!-- [(activeSlide)]="selectedIndexcomment" -->
    <carousel [interval]="0" [(activeSlide)]="selectedIndexcomment">
      @for (item of commentimgArray; track item; let i = $index) {
        <slide>
          <div>
            <img [src]="item" class="image-preview preview-doc" />
            <!-- style="display: block; width: 80%; height: auto; text-align: center;margin: 0 auto;" /> -->
          </div>
        </slide>
      }
    </carousel>
  </div>
</p-dialog>

<p-confirmDialog [style]="{ width: '23vw' }" [baseZIndex]="999999999"></p-confirmDialog>
